var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDvtBenefits1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 461,
    height: 311,
    viewBox: "0 0 461 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_837_235)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 453,
    height: 303,
    rx: 8,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.998 274.334H4V285.463H221.998V274.334Z",
    fill: "#4C417D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.914 285.278H142.686V286.263H143.914V285.278Z",
    fill: "#282142"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.457 285.278H140.229V286.263H141.457V285.278Z",
    fill: "#282142"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.04 273.533H132.811V274.52H134.04V273.533Z",
    fill: "#282142"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.326 273.533H145.098V274.52H146.326V273.533Z",
    fill: "#282142"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.413 273.533H140.184V274.52H141.413V273.533Z",
    fill: "#282142"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.541 285.278H135.313V286.263H136.541V285.278Z",
    fill: "#282142"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.496 273.533H135.268V274.52H136.496V273.533Z",
    fill: "#282142"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.085 285.278H132.856V286.263H134.085V285.278Z",
    fill: "#282142"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.529 273.533H162.3V274.52H163.529V273.533Z",
    fill: "#282142"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.956 273.533H137.725V274.52H138.956V273.533Z",
    fill: "#282142"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M138.998 285.278H137.769V286.263H138.998V285.278Z",
    fill: "#282142"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M143.869 273.533H142.641V274.52H143.869V273.533Z",
    fill: "#282142"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M158.615 273.533H157.384V274.52H158.615V273.533Z",
    fill: "#282142"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M156.201 285.278H154.972V286.263H156.201V285.278Z",
    fill: "#282142"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M158.657 285.278H157.429V286.263H158.657V285.278Z",
    fill: "#282142"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M156.156 273.533H154.927V274.52H156.156V273.533Z",
    fill: "#282142"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M161.117 285.278H159.886V286.263H161.117V285.278Z",
    fill: "#282142"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M161.072 273.533H159.844V274.52H161.072V273.533Z",
    fill: "#282142"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M153.744 285.278H152.516V286.263H153.744V285.278Z",
    fill: "#282142"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M148.828 285.278H147.599V286.263H148.828V285.278Z",
    fill: "#282142"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M151.242 273.533H150.014V274.52H151.242V273.533Z",
    fill: "#282142"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M153.699 273.533H152.47V274.52H153.699V273.533Z",
    fill: "#282142"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M151.287 285.278H150.059V286.263H151.287V285.278Z",
    fill: "#282142"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M148.785 273.533H147.554V274.52H148.785V273.533Z",
    fill: "#282142"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M146.371 285.278H145.142V286.263H146.371V285.278Z",
    fill: "#282142"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M111.924 273.533H110.695V274.52H111.924V273.533Z",
    fill: "#282142"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M102.094 273.533H100.865V274.52H102.094V273.533Z",
    fill: "#282142"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M111.968 285.278H110.74V286.263H111.968V285.278Z",
    fill: "#282142"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M109.509 285.278H108.28V286.263H109.509V285.278Z",
    fill: "#282142"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M114.38 273.533H113.152V274.52H114.38V273.533Z",
    fill: "#282142"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M114.425 285.278H113.197V286.263H114.425V285.278Z",
    fill: "#282142"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M116.837 273.533H115.609V274.52H116.837V273.533Z",
    fill: "#282142"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M104.551 273.533H103.322V274.52H104.551V273.533Z",
    fill: "#282142"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M107.052 285.278H105.824V286.263H107.052V285.278Z",
    fill: "#282142"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M102.139 285.278H100.91V286.263H102.139V285.278Z",
    fill: "#282142"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M107.007 273.533H105.779V274.52H107.007V273.533Z",
    fill: "#282142"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M104.596 285.278H103.367V286.263H104.596V285.278Z",
    fill: "#282142"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M116.882 285.278H115.653V286.263H116.882V285.278Z",
    fill: "#282142"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M126.712 285.278H125.483V286.263H126.712V285.278Z",
    fill: "#282142"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M126.667 273.533H125.438V274.52H126.667V273.533Z",
    fill: "#282142"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M129.126 273.533H127.895V274.52H129.126V273.533Z",
    fill: "#282142"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M129.168 285.278H127.94V286.263H129.168V285.278Z",
    fill: "#282142"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M124.255 285.278H123.026V286.263H124.255V285.278Z",
    fill: "#282142"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M131.583 273.533H130.354V274.52H131.583V273.533Z",
    fill: "#282142"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M131.628 285.278H130.399V286.263H131.628V285.278Z",
    fill: "#282142"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M119.339 285.278H118.11V286.263H119.339V285.278Z",
    fill: "#282142"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M124.21 273.533H122.982V274.52H124.21V273.533Z",
    fill: "#282142"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M119.297 273.533H118.068V274.52H119.297V273.533Z",
    fill: "#282142"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M121.753 273.533H120.525V274.52H121.753V273.533Z",
    fill: "#282142"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M121.798 285.278H120.57V286.263H121.798V285.278Z",
    fill: "#282142"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M109.467 273.533H108.238V274.52H109.467V273.533Z",
    fill: "#282142"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M205.304 273.533H204.076V274.52H205.304V273.533Z",
    fill: "#282142"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M205.349 285.278H204.121V286.263H205.349V285.278Z",
    fill: "#282142"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M202.847 273.533H201.619V274.52H202.847V273.533Z",
    fill: "#282142"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M210.22 273.533H208.989V274.52H210.22V273.533Z",
    fill: "#282142"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M207.761 273.533H206.532V274.52H207.761V273.533Z",
    fill: "#282142"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M207.806 285.278H206.577V286.263H207.806V285.278Z",
    fill: "#282142"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M202.892 285.278H201.664V286.263H202.892V285.278Z",
    fill: "#282142"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M195.519 285.278H194.291V286.263H195.519V285.278Z",
    fill: "#282142"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M200.435 285.278H199.204V286.263H200.435V285.278Z",
    fill: "#282142"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M197.931 273.533H196.703V274.52H197.931V273.533Z",
    fill: "#282142"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M200.391 273.533H199.159V274.52H200.391V273.533Z",
    fill: "#282142"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M197.976 285.278H196.748V286.263H197.976V285.278Z",
    fill: "#282142"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M220.092 285.278H218.864V286.263H220.092V285.278Z",
    fill: "#282142"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M217.636 285.278H216.407V286.263H217.636V285.278Z",
    fill: "#282142"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M221.998 273.533H221.278V274.52H221.998V273.533Z",
    fill: "#282142"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M220.05 273.533H218.819V274.52H220.05V273.533Z",
    fill: "#282142"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M195.475 273.533H194.246V274.52H195.475V273.533Z",
    fill: "#282142"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M221.998 285.278H221.323V286.263H221.998V285.278Z",
    fill: "#282142"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M212.677 273.533H211.449V274.52H212.677V273.533Z",
    fill: "#282142"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M217.591 273.533H216.362V274.52H217.591V273.533Z",
    fill: "#282142"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M210.265 285.278H209.034V286.263H210.265V285.278Z",
    fill: "#282142"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M212.722 285.278H211.494V286.263H212.722V285.278Z",
    fill: "#282142"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M163.574 285.278H162.345V286.263H163.574V285.278Z",
    fill: "#282142"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M215.134 273.533H213.906V274.52H215.134V273.533Z",
    fill: "#282142"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M215.179 285.278H213.95V286.263H215.179V285.278Z",
    fill: "#282142"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M175.815 273.533H174.587V274.52H175.815V273.533Z",
    fill: "#282142"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M170.947 285.278H169.715V286.263H170.947V285.278Z",
    fill: "#282142"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M173.358 273.533H172.13V274.52H173.358V273.533Z",
    fill: "#282142"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M193.063 285.278H191.834V286.263H193.063V285.278Z",
    fill: "#282142"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M178.272 273.533H177.043V274.52H178.272V273.533Z",
    fill: "#282142"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M175.86 285.278H174.632V286.263H175.86V285.278Z",
    fill: "#282142"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M166.03 285.278H164.802V286.263H166.03V285.278Z",
    fill: "#282142"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M178.317 285.278H177.088V286.263H178.317V285.278Z",
    fill: "#282142"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M165.986 273.533H164.757V274.52H165.986V273.533Z",
    fill: "#282142"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M170.902 273.533H169.673V274.52H170.902V273.533Z",
    fill: "#282142"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M168.487 285.278H167.259V286.263H168.487V285.278Z",
    fill: "#282142"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M168.442 273.533H167.214V274.52H168.442V273.533Z",
    fill: "#282142"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M173.403 285.278H172.175V286.263H173.403V285.278Z",
    fill: "#282142"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M190.561 273.533H189.333V274.52H190.561V273.533Z",
    fill: "#282142"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M188.146 285.278H186.918V286.263H188.146V285.278Z",
    fill: "#282142"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M190.606 285.278H189.375V286.263H190.606V285.278Z",
    fill: "#282142"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M188.102 273.533H186.873V274.52H188.102V273.533Z",
    fill: "#282142"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M193.018 273.533H191.789V274.52H193.018V273.533Z",
    fill: "#282142"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M183.188 273.533H181.96V274.52H183.188V273.533Z",
    fill: "#282142"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M180.776 285.278H179.545V286.263H180.776V285.278Z",
    fill: "#282142"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M180.731 273.533H179.503V274.52H180.731V273.533Z",
    fill: "#282142"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M185.69 285.278H184.461V286.263H185.69V285.278Z",
    fill: "#282142"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M185.645 273.533H184.417V274.52H185.645V273.533Z",
    fill: "#282142"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M183.233 285.278H182.004V286.263H183.233V285.278Z",
    fill: "#282142"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7581 285.278H7.52698V286.263H8.7581V285.278Z",
    fill: "#282142"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5429 273.533H17.3145V274.52H18.5429V273.533Z",
    fill: "#282142"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5878 285.278H17.3567V286.263H18.5878V285.278Z",
    fill: "#282142"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1282 285.278H14.8998V286.263H16.1282V285.278Z",
    fill: "#282142"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0834 273.533H14.855V274.52H16.0834V273.533Z",
    fill: "#282142"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0446 285.278H19.8162V286.263H21.0446V285.278Z",
    fill: "#282142"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9995 273.533H19.7711V274.52H20.9995V273.533Z",
    fill: "#282142"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2985 285.278H5.07007V286.263H6.2985V285.278Z",
    fill: "#282142"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4565 273.533H22.228V274.52H23.4565V273.533Z",
    fill: "#282142"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1698 273.533H9.94141V274.52H11.1698V273.533Z",
    fill: "#282142"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71317 273.533H7.48474V274.52H8.71317V273.533Z",
    fill: "#282142"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6268 273.533H12.3983V274.52H13.6268V273.533Z",
    fill: "#282142"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2148 285.278H9.98633V286.263H11.2148V285.278Z",
    fill: "#282142"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6716 285.278H12.4431V286.263H13.6716V285.278Z",
    fill: "#282142"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M33.331 285.278H32.1025V286.263H33.331V285.278Z",
    fill: "#282142"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2861 273.533H32.0576V274.52H33.2861V273.533Z",
    fill: "#282142"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8741 285.278H29.6456V286.263H30.8741V285.278Z",
    fill: "#282142"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7427 273.533H34.5143V274.52H35.7427V273.533Z",
    fill: "#282142"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2021 273.533H36.9709V274.52H38.2021V273.533Z",
    fill: "#282142"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7876 285.278H34.5592V286.263H35.7876V285.278Z",
    fill: "#282142"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4146 285.278H27.1862V286.263H28.4146V285.278Z",
    fill: "#282142"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9579 285.278H24.7295V286.263H25.9579V285.278Z",
    fill: "#282142"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6791 285.278H98.4507V286.263H99.6791V285.278Z",
    fill: "#282142"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M25.913 273.533H24.6846V274.52H25.913V273.533Z",
    fill: "#282142"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3726 273.533H27.1415V274.52H28.3726V273.533Z",
    fill: "#282142"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5013 285.278H22.2728V286.263H23.5013V285.278Z",
    fill: "#282142"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2537 273.533H5.02527V274.52H6.2537V273.533Z",
    fill: "#282142"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2442 285.278H37.0157V286.263H38.2442V285.278Z",
    fill: "#282142"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8293 273.533H29.6008V274.52H30.8293V273.533Z",
    fill: "#282142"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0226 285.278H78.7915V286.263H80.0226V285.278Z",
    fill: "#282142"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M40.659 273.533H39.4305V274.52H40.659V273.533Z",
    fill: "#282142"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4344 273.533H81.2059V274.52H82.4344V273.533Z",
    fill: "#282142"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9778 273.533H78.7494V274.52H79.9778V273.533Z",
    fill: "#282142"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4792 285.278H81.2507V286.263H82.4792V285.278Z",
    fill: "#282142"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1928 285.278H68.9617V286.263H70.1928V285.278Z",
    fill: "#282142"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6047 273.533H71.3762V274.52H72.6047V273.533Z",
    fill: "#282142"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6496 285.278H71.4211V286.263H72.6496V285.278Z",
    fill: "#282142"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9362 285.278H83.7078V286.263H84.9362V285.278Z",
    fill: "#282142"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1064 285.278H73.8779V286.263H75.1064V285.278Z",
    fill: "#282142"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5209 273.533H76.2898V274.52H77.5209V273.533Z",
    fill: "#282142"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0616 273.533H73.8331V274.52H75.0616V273.533Z",
    fill: "#282142"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8913 273.533H83.6628V274.52H84.8913V273.533Z",
    fill: "#282142"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1775 273.533H95.9491V274.52H97.1775V273.533Z",
    fill: "#282142"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3479 273.533H86.1195V274.52H87.3479V273.533Z",
    fill: "#282142"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M94.721 273.533H93.4926V274.52H94.721V273.533Z",
    fill: "#282142"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6371 273.533H98.4087V274.52H99.6371V273.533Z",
    fill: "#282142"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2225 285.278H95.994V286.263H97.2225V285.278Z",
    fill: "#282142"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7658 285.278H93.5374V286.263H94.7658V285.278Z",
    fill: "#282142"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3927 285.278H86.1643V286.263H87.3927V285.278Z",
    fill: "#282142"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8074 273.533H88.579V274.52H89.8074V273.533Z",
    fill: "#282142"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2641 273.533H91.0356V274.52H92.2641V273.533Z",
    fill: "#282142"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M92.309 285.278H91.0806V286.263H92.309V285.278Z",
    fill: "#282142"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8523 285.278H88.6212V286.263H89.8523V285.278Z",
    fill: "#282142"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M77.563 285.278H76.3346V286.263H77.563V285.278Z",
    fill: "#282142"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4886 273.533H49.2601V274.52H50.4886V273.533Z",
    fill: "#282142"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M70.148 273.533H68.9196V274.52H70.148V273.533Z",
    fill: "#282142"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5335 285.278H49.3051V286.263H50.5335V285.278Z",
    fill: "#282142"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9455 273.533H51.717V274.52H52.9455V273.533Z",
    fill: "#282142"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0318 273.533H46.8007V274.52H48.0318V273.533Z",
    fill: "#282142"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9904 285.278H51.762V286.263H52.9904V285.278Z",
    fill: "#282142"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7038 285.278H39.4753V286.263H40.7038V285.278Z",
    fill: "#282142"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1158 273.533H41.8873V274.52H43.1158V273.533Z",
    fill: "#282142"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4021 273.533H54.1737V274.52H55.4021V273.533Z",
    fill: "#282142"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5724 273.533H44.344V274.52H45.5724V273.533Z",
    fill: "#282142"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1607 285.278H41.9323V286.263H43.1607V285.278Z",
    fill: "#282142"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6174 285.278H44.3889V286.263H45.6174V285.278Z",
    fill: "#282142"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0741 285.278H46.8457V286.263H48.0741V285.278Z",
    fill: "#282142"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2766 285.278H64.0482V286.263H65.2766V285.278Z",
    fill: "#282142"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2317 273.533H64.0033V274.52H65.2317V273.533Z",
    fill: "#282142"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7333 285.278H66.5049V286.263H67.7333V285.278Z",
    fill: "#282142"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6911 273.533H66.46V274.52H67.6911V273.533Z",
    fill: "#282142"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M62.82 285.278H61.5916V286.263H62.82V285.278Z",
    fill: "#282142"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9036 285.278H56.6752V286.263H57.9036V285.278Z",
    fill: "#282142"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4469 285.278H54.2185V286.263H55.4469V285.278Z",
    fill: "#282142"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8614 273.533H56.6302V274.52H57.8614V273.533Z",
    fill: "#282142"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3183 273.533H59.0898V274.52H60.3183V273.533Z",
    fill: "#282142"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3632 285.278H59.1348V286.263H60.3632V285.278Z",
    fill: "#282142"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7752 273.533H61.5468V274.52H62.7752V273.533Z",
    fill: "#282142"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M221.998 284.97H4V285.954H221.998V284.97Z",
    fill: "#282142"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M221.998 273.842H4V274.826H221.998V273.842Z",
    fill: "#282142"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M193.573 281.902C194.616 283.108 196.442 283.237 197.648 282.193C198.854 281.147 198.983 279.321 197.937 278.116C196.891 276.912 195.068 276.781 193.862 277.827C192.656 278.873 192.527 280.696 193.573 281.902ZM194.622 278.704C195.343 278.079 196.434 278.157 197.059 278.878C197.684 279.599 197.609 280.69 196.888 281.315C196.167 281.941 195.073 281.862 194.451 281.142C193.826 280.421 193.901 279.33 194.622 278.704Z",
    fill: "#282142"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M163.428 281.902C164.474 283.108 166.3 283.237 167.505 282.193C168.708 281.147 168.84 279.321 167.794 278.116C166.748 276.912 164.925 276.781 163.719 277.827C162.513 278.873 162.384 280.696 163.428 281.902ZM164.479 278.704C165.2 278.079 166.291 278.157 166.916 278.878C167.542 279.599 167.463 280.69 166.743 281.315C166.022 281.941 164.931 281.862 164.305 281.142C163.68 280.421 163.759 279.33 164.479 278.704Z",
    fill: "#282142"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M133.285 281.902C134.331 283.108 136.154 283.237 137.36 282.193C138.566 281.147 138.695 279.321 137.652 278.116C136.606 276.912 134.78 276.781 133.574 277.827C132.371 278.873 132.239 280.696 133.285 281.902ZM134.337 278.704C135.058 278.079 136.149 278.157 136.774 278.878C137.4 279.599 137.321 280.69 136.6 281.315C135.879 281.941 134.789 281.862 134.163 281.142C133.537 280.421 133.616 279.33 134.337 278.704Z",
    fill: "#282142"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M103.143 281.902C104.186 283.108 106.012 283.237 107.218 282.193C108.424 281.147 108.553 279.321 107.507 278.116C106.463 276.912 104.638 276.781 103.432 277.827C102.226 278.873 102.097 280.696 103.143 281.902ZM104.191 278.704C104.912 278.079 106.003 278.157 106.629 278.878C107.254 279.599 107.178 280.69 106.457 281.315C105.737 281.941 104.646 281.862 104.02 281.142C103.395 280.421 103.471 279.33 104.191 278.704Z",
    fill: "#282142"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9973 281.902C74.0433 283.108 75.8691 283.237 77.0749 282.193C78.278 281.147 78.4099 279.321 77.3638 278.116C76.3178 276.912 74.4949 276.781 73.2889 277.827C72.0831 278.873 71.9541 280.696 72.9973 281.902ZM74.0489 278.704C74.7697 278.079 75.8606 278.157 76.486 278.878C77.1115 279.599 77.0329 280.69 76.3122 281.315C75.5914 281.941 74.5005 281.862 73.875 281.142C73.2498 280.421 73.3284 279.33 74.0489 278.704Z",
    fill: "#282142"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1929 280.513V280.516C42.2799 281.013 42.4987 281.492 42.8547 281.902C43.9007 283.108 45.7236 283.237 46.9296 282.193C48.1356 281.147 48.2646 279.322 47.2213 278.116C46.2284 276.974 44.5345 276.798 43.3343 277.675C43.2697 277.723 43.2053 277.773 43.1436 277.827C42.3499 278.517 42.022 279.546 42.1929 280.513ZM43.9066 278.704C44.6273 278.079 45.7182 278.157 46.3437 278.878C46.9691 279.599 46.8906 280.69 46.1698 281.315C45.4491 281.941 44.3581 281.862 43.7327 281.142C43.1073 280.421 43.1858 279.33 43.9066 278.704Z",
    fill: "#282142"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7123 281.902C13.7555 283.108 15.5813 283.237 16.7873 282.193C17.9933 281.147 18.1223 279.321 17.0762 278.116C16.0329 276.912 14.2073 276.781 13.0013 277.827C11.7953 278.873 11.6663 280.696 12.7123 281.902ZM13.7613 278.704C14.4821 278.079 15.573 278.157 16.1984 278.878C16.8238 279.599 16.748 280.69 16.0272 281.315C15.3065 281.941 14.2156 281.862 13.5901 281.142C12.9647 280.421 13.0405 279.33 13.7613 278.704Z",
    fill: "#282142"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M444.823 274.286H206.995V285.415H444.823C446.359 285.415 447.75 284.792 448.757 283.785C449.763 282.778 450.386 281.387 450.386 279.851C450.386 276.777 447.895 274.286 444.823 274.286Z",
    fill: "#4C417D"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M286.307 273.486H285.078V274.471H286.307V273.486Z",
    fill: "#282142"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M288.763 273.486H287.535V274.471H288.763V273.486Z",
    fill: "#282142"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M296.181 285.229H294.953V286.216H296.181V285.229Z",
    fill: "#282142"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M283.895 285.229H282.667V286.216H283.895V285.229Z",
    fill: "#282142"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M288.808 285.229H287.58V286.216H288.808V285.229Z",
    fill: "#282142"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M293.68 273.486H292.451V274.471H293.68V273.486Z",
    fill: "#282142"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M293.725 285.229H292.496V286.216H293.725V285.229Z",
    fill: "#282142"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M296.137 273.486H294.908V274.471H296.137V273.486Z",
    fill: "#282142"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M266.692 285.229H265.464V286.216H266.692V285.229Z",
    fill: "#282142"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M291.268 285.229H290.037V286.216H291.268V285.229Z",
    fill: "#282142"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M291.223 273.486H289.995V274.471H291.223V273.486Z",
    fill: "#282142"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M286.352 285.229H285.123V286.216H286.352V285.229Z",
    fill: "#282142"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M271.608 285.229H270.377V286.216H271.608V285.229Z",
    fill: "#282142"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M274.021 273.486H272.792V274.471H274.021V273.486Z",
    fill: "#282142"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M271.564 273.486H270.335V274.471H271.564V273.486Z",
    fill: "#282142"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M274.065 285.229H272.837V286.216H274.065V285.229Z",
    fill: "#282142"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M269.107 273.486H267.876V274.471H269.107V273.486Z",
    fill: "#282142"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M269.149 285.229H267.921V286.216H269.149V285.229Z",
    fill: "#282142"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M276.477 273.486H275.249V274.471H276.477V273.486Z",
    fill: "#282142"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M281.393 273.486H280.165V274.471H281.393V273.486Z",
    fill: "#282142"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M278.979 285.229H277.75V286.216H278.979V285.229Z",
    fill: "#282142"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M276.522 285.229H275.293V286.216H276.522V285.229Z",
    fill: "#282142"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M278.934 273.486H277.705V274.471H278.934V273.486Z",
    fill: "#282142"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M281.438 285.229H280.207V286.216H281.438V285.229Z",
    fill: "#282142"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M283.85 273.486H282.622V274.471H283.85V273.486Z",
    fill: "#282142"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M318.297 285.229H317.069V286.216H318.297V285.229Z",
    fill: "#282142"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M328.127 285.229H326.899V286.216H328.127V285.229Z",
    fill: "#282142"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M318.253 273.486H317.024V274.471H318.253V273.486Z",
    fill: "#282142"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M320.712 273.486H319.484V274.471H320.712V273.486Z",
    fill: "#282142"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M315.841 285.229H314.612V286.216H315.841V285.229Z",
    fill: "#282142"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M315.796 273.486H314.568V274.471H315.796V273.486Z",
    fill: "#282142"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M313.384 285.229H312.156V286.216H313.384V285.229Z",
    fill: "#282142"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M325.67 285.229H324.442V286.216H325.67V285.229Z",
    fill: "#282142"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M323.169 273.486H321.94V274.471H323.169V273.486Z",
    fill: "#282142"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M328.082 273.486H326.854V274.471H328.082V273.486Z",
    fill: "#282142"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M323.214 285.229H321.985V286.216H323.214V285.229Z",
    fill: "#282142"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M325.626 273.486H324.397V274.471H325.626V273.486Z",
    fill: "#282142"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M313.339 273.486H312.111V274.471H313.339V273.486Z",
    fill: "#282142"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M303.509 273.486H302.281V274.471H303.509V273.486Z",
    fill: "#282142"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M303.554 285.229H302.326V286.216H303.554V285.229Z",
    fill: "#282142"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M301.098 285.229H299.866V286.216H301.098V285.229Z",
    fill: "#282142"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M301.053 273.486H299.824V274.471H301.053V273.486Z",
    fill: "#282142"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M305.966 273.486H304.738V274.471H305.966V273.486Z",
    fill: "#282142"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M298.638 285.229H297.41V286.216H298.638V285.229Z",
    fill: "#282142"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M298.593 273.486H297.365V274.471H298.593V273.486Z",
    fill: "#282142"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M310.883 273.486H309.654V274.471H310.883V273.486Z",
    fill: "#282142"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M306.011 285.229H304.783V286.216H306.011V285.229Z",
    fill: "#282142"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M310.925 285.229H309.696V286.216H310.925V285.229Z",
    fill: "#282142"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M308.468 285.229H307.239V286.216H308.468V285.229Z",
    fill: "#282142"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M308.423 273.486H307.194V274.471H308.423V273.486Z",
    fill: "#282142"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M320.754 285.229H319.526V286.216H320.754V285.229Z",
    fill: "#282142"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M224.917 285.229H223.688V286.216H224.917V285.229Z",
    fill: "#282142"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M224.872 273.486H223.644V274.471H224.872V273.486Z",
    fill: "#282142"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M227.373 285.229H226.145V286.216H227.373V285.229Z",
    fill: "#282142"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M220.003 285.229H218.772V286.216H220.003V285.229Z",
    fill: "#282142"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M222.46 285.229H221.232V286.216H222.46V285.229Z",
    fill: "#282142"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M222.415 273.486H221.187V274.471H222.415V273.486Z",
    fill: "#282142"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M227.329 273.486H226.1V274.471H227.329V273.486Z",
    fill: "#282142"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M234.702 273.486H233.473V274.471H234.702V273.486Z",
    fill: "#282142"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M229.788 273.486H228.557V274.471H229.788V273.486Z",
    fill: "#282142"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M232.29 285.229H231.061V286.216H232.29V285.229Z",
    fill: "#282142"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M229.833 285.229H228.602V286.216H229.833V285.229Z",
    fill: "#282142"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M232.245 273.486H231.016V274.471H232.245V273.486Z",
    fill: "#282142"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M449.934 278.17C450.052 278.526 450.13 278.896 450.17 279.269L450.355 279.25L450.843 279.196L451.151 279.162C451.104 278.719 451.008 278.285 450.868 277.861L450.576 277.956L450.108 278.111L449.934 278.17Z",
    fill: "#282142"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M210.129 273.486H208.9V274.471H210.129V273.486Z",
    fill: "#282142"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M212.586 273.486H211.357V274.471H212.586V273.486Z",
    fill: "#282142"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M207.714 285.229H206.995V286.216H207.714V285.229Z",
    fill: "#282142"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M210.174 285.229H208.943V286.216H210.174V285.229Z",
    fill: "#282142"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M234.747 285.229H233.518V286.216H234.747V285.229Z",
    fill: "#282142"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M207.669 273.486H206.995V274.471H207.669V273.486Z",
    fill: "#282142"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M217.544 285.229H216.315V286.216H217.544V285.229Z",
    fill: "#282142"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M212.63 285.229H211.402V286.216H212.63V285.229Z",
    fill: "#282142"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M219.958 273.486H218.727V274.471H219.958V273.486Z",
    fill: "#282142"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M217.499 273.486H216.271V274.471H217.499V273.486Z",
    fill: "#282142"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M266.647 273.486H265.419V274.471H266.647V273.486Z",
    fill: "#282142"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M215.087 285.229H213.859V286.216H215.087V285.229Z",
    fill: "#282142"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M215.042 273.486H213.814V274.471H215.042V273.486Z",
    fill: "#282142"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M254.406 285.229H253.177V286.216H254.406V285.229Z",
    fill: "#282142"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M259.277 273.486H258.046V274.471H259.277V273.486Z",
    fill: "#282142"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M256.863 285.229H255.634V286.216H256.863V285.229Z",
    fill: "#282142"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M237.158 273.486H235.93V274.471H237.158V273.486Z",
    fill: "#282142"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M251.949 285.229H250.721V286.216H251.949V285.229Z",
    fill: "#282142"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M254.361 273.486H253.133V274.471H254.361V273.486Z",
    fill: "#282142"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M264.191 273.486H262.962V274.471H264.191V273.486Z",
    fill: "#282142"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M251.904 273.486H250.676V274.471H251.904V273.486Z",
    fill: "#282142"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M264.236 285.229H263.007V286.216H264.236V285.229Z",
    fill: "#282142"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M259.319 285.229H258.091V286.216H259.319V285.229Z",
    fill: "#282142"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M261.734 273.486H260.505V274.471H261.734V273.486Z",
    fill: "#282142"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M261.779 285.229H260.55V286.216H261.779V285.229Z",
    fill: "#282142"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M256.818 273.486H255.589V274.471H256.818V273.486Z",
    fill: "#282142"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M239.66 285.229H238.431V286.216H239.66V285.229Z",
    fill: "#282142"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M242.074 273.486H240.846V274.471H242.074V273.486Z",
    fill: "#282142"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M239.618 273.486H238.386V274.471H239.618V273.486Z",
    fill: "#282142"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M242.119 285.229H240.891V286.216H242.119V285.229Z",
    fill: "#282142"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M237.203 285.229H235.975V286.216H237.203V285.229Z",
    fill: "#282142"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M247.033 285.229H245.804V286.216H247.033V285.229Z",
    fill: "#282142"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M249.447 273.486H248.216V274.471H249.447V273.486Z",
    fill: "#282142"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M249.49 285.229H248.261V286.216H249.49V285.229Z",
    fill: "#282142"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M244.531 273.486H243.303V274.471H244.531V273.486Z",
    fill: "#282142"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M244.576 285.229H243.348V286.216H244.576V285.229Z",
    fill: "#282142"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M246.988 273.486H245.76V274.471H246.988V273.486Z",
    fill: "#282142"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M421.466 273.486H420.234V274.471H421.466V273.486Z",
    fill: "#282142"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M411.678 285.229H410.45V286.216H411.678V285.229Z",
    fill: "#282142"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M411.636 273.486H410.405V274.471H411.636V273.486Z",
    fill: "#282142"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M414.093 273.486H412.864V274.471H414.093V273.486Z",
    fill: "#282142"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M414.138 285.229H412.909V286.216H414.138V285.229Z",
    fill: "#282142"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M409.176 273.486H407.948V274.471H409.176V273.486Z",
    fill: "#282142"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M409.221 285.229H407.993V286.216H409.221V285.229Z",
    fill: "#282142"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M423.922 273.486H422.694V274.471H423.922V273.486Z",
    fill: "#282142"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M406.765 285.229H405.536V286.216H406.765V285.229Z",
    fill: "#282142"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M419.051 285.229H417.823V286.216H419.051V285.229Z",
    fill: "#282142"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M421.508 285.229H420.279V286.216H421.508V285.229Z",
    fill: "#282142"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M416.594 285.229H415.366V286.216H416.594V285.229Z",
    fill: "#282142"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M419.006 273.486H417.778V274.471H419.006V273.486Z",
    fill: "#282142"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M416.55 273.486H415.321V274.471H416.55V273.486Z",
    fill: "#282142"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M396.89 273.486H395.662V274.471H396.89V273.486Z",
    fill: "#282142"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M396.935 285.229H395.707V286.216H396.935V285.229Z",
    fill: "#282142"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M399.347 273.486H398.118V274.471H399.347V273.486Z",
    fill: "#282142"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M394.478 285.229H393.25V286.216H394.478V285.229Z",
    fill: "#282142"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M392.021 285.229H390.79V286.216H392.021V285.229Z",
    fill: "#282142"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M394.433 273.486H393.205V274.471H394.433V273.486Z",
    fill: "#282142"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M401.806 273.486H400.578V274.471H401.806V273.486Z",
    fill: "#282142"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M404.263 273.486H403.035V274.471H404.263V273.486Z",
    fill: "#282142"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M330.542 273.486H329.313V274.471H330.542V273.486Z",
    fill: "#282142"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M404.308 285.229H403.079V286.216H404.308V285.229Z",
    fill: "#282142"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M401.851 285.229H400.62V286.216H401.851V285.229Z",
    fill: "#282142"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M406.72 273.486H405.491V274.471H406.72V273.486Z",
    fill: "#282142"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M438.666 273.486H437.437V274.471H438.666V273.486Z",
    fill: "#282142"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M446.008 285.287L445.969 285.108C445.604 285.186 445.228 285.228 444.852 285.228V285.416L444.855 285.907L444.858 286.216C445.301 286.213 445.747 286.162 446.179 286.07L446.111 285.767L446.008 285.287Z",
    fill: "#282142"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M443.582 273.486H442.353V274.471H443.582V273.486Z",
    fill: "#282142"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M445.969 274.403L446.067 273.924L446.131 273.621C445.702 273.531 445.262 273.486 444.822 273.486H444.811V274.471H444.822C445.195 274.471 445.568 274.51 445.93 274.586L445.969 274.403Z",
    fill: "#282142"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M443.627 285.229H442.398V286.216H443.627V285.229Z",
    fill: "#282142"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M441.167 285.229H439.939V286.216H441.167V285.229Z",
    fill: "#282142"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M423.967 285.229H422.739V286.216H423.967V285.229Z",
    fill: "#282142"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M441.122 273.486H439.894V274.471H441.122V273.486Z",
    fill: "#282142"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M449.654 282.612L449.491 282.52C449.306 282.842 449.084 283.151 448.835 283.431L448.972 283.554L449.34 283.883L449.57 284.087C449.864 283.754 450.128 283.392 450.346 283.008L450.077 282.853L449.654 282.612Z",
    fill: "#282142"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M450.848 280.458L450.357 280.41L450.175 280.391C450.136 280.766 450.06 281.134 449.945 281.49L450.122 281.546L450.59 281.698L450.885 281.793C451.019 281.369 451.112 280.932 451.154 280.489L450.848 280.458Z",
    fill: "#282142"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M448.114 284.337L448.002 284.185C447.702 284.41 447.374 284.6 447.034 284.755L447.11 284.923L447.312 285.369L447.441 285.652C447.844 285.47 448.229 285.243 448.588 284.979L448.405 284.732L448.114 284.337Z",
    fill: "#282142"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M449.631 277.054L450.055 276.807L450.324 276.65C450.099 276.268 449.836 275.909 449.539 275.578L449.309 275.786L448.947 276.114L448.807 276.24C449.059 276.521 449.283 276.824 449.471 277.146L449.631 277.054Z",
    fill: "#282142"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M448.08 275.34L448.366 274.942L448.549 274.692C448.19 274.431 447.8 274.21 447.396 274.03L447.27 274.314L447.073 274.762L446.998 274.931C447.337 275.082 447.665 275.27 447.971 275.491L448.08 275.34Z",
    fill: "#282142"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M438.711 285.229H437.482V286.216H438.711V285.229Z",
    fill: "#282142"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M431.293 273.486H430.064V274.471H431.293V273.486Z",
    fill: "#282142"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M428.836 273.486H427.608V274.471H428.836V273.486Z",
    fill: "#282142"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M428.881 285.229H427.652V286.216H428.881V285.229Z",
    fill: "#282142"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M426.379 273.486H425.151V274.471H426.379V273.486Z",
    fill: "#282142"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M426.424 285.229H425.196V286.216H426.424V285.229Z",
    fill: "#282142"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M433.797 285.229H432.569V286.216H433.797V285.229Z",
    fill: "#282142"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M436.254 285.229H435.025V286.216H436.254V285.229Z",
    fill: "#282142"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M436.209 273.486H434.98V274.471H436.209V273.486Z",
    fill: "#282142"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M433.752 273.486H432.524V274.471H433.752V273.486Z",
    fill: "#282142"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M391.977 273.486H390.748V274.471H391.977V273.486Z",
    fill: "#282142"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M431.337 285.229H430.109V286.216H431.337V285.229Z",
    fill: "#282142"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M399.392 285.229H398.163V286.216H399.392V285.229Z",
    fill: "#282142"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M350.201 273.486H348.97V274.471H350.201V273.486Z",
    fill: "#282142"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M389.562 285.229H388.334V286.216H389.562V285.229Z",
    fill: "#282142"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M347.787 285.229H346.558V286.216H347.787V285.229Z",
    fill: "#282142"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M350.243 285.229H349.015V286.216H350.243V285.229Z",
    fill: "#282142"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M347.742 273.486H346.513V274.471H347.742V273.486Z",
    fill: "#282142"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M360.031 273.486H358.8V274.471H360.031V273.486Z",
    fill: "#282142"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M357.616 285.229H356.388V286.216H357.616V285.229Z",
    fill: "#282142"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M357.571 273.486H356.343V274.471H357.571V273.486Z",
    fill: "#282142"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M345.285 273.486H344.057V274.471H345.285V273.486Z",
    fill: "#282142"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M355.115 273.486H353.886V274.471H355.115V273.486Z",
    fill: "#282142"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M352.703 285.229H351.472V286.216H352.703V285.229Z",
    fill: "#282142"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M355.16 285.229H353.931V286.216H355.16V285.229Z",
    fill: "#282142"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M345.33 285.229H344.102V286.216H345.33V285.229Z",
    fill: "#282142"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M333.043 285.229H331.815V286.216H333.043V285.229Z",
    fill: "#282142"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M342.873 285.229H341.645V286.216H342.873V285.229Z",
    fill: "#282142"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M335.5 285.229H334.272V286.216H335.5V285.229Z",
    fill: "#282142"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M330.584 285.229H329.355V286.216H330.584V285.229Z",
    fill: "#282142"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M332.998 273.486H331.77V274.471H332.998V273.486Z",
    fill: "#282142"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M335.455 273.486H334.227V274.471H335.455V273.486Z",
    fill: "#282142"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M342.828 273.486H341.6V274.471H342.828V273.486Z",
    fill: "#282142"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M340.414 285.229H339.185V286.216H340.414V285.229Z",
    fill: "#282142"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M337.957 285.229H336.728V286.216H337.957V285.229Z",
    fill: "#282142"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M337.912 273.486H336.684V274.471H337.912V273.486Z",
    fill: "#282142"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M340.371 273.486H339.14V274.471H340.371V273.486Z",
    fill: "#282142"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M352.658 273.486H351.429V274.471H352.658V273.486Z",
    fill: "#282142"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M379.732 285.229H378.504V286.216H379.732V285.229Z",
    fill: "#282142"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M360.073 285.229H358.844V286.216H360.073V285.229Z",
    fill: "#282142"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M379.687 273.486H378.459V274.471H379.687V273.486Z",
    fill: "#282142"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M377.276 285.229H376.047V286.216H377.276V285.229Z",
    fill: "#282142"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M382.192 285.229H380.961V286.216H382.192V285.229Z",
    fill: "#282142"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M377.231 273.486H376.002V274.471H377.231V273.486Z",
    fill: "#282142"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M389.517 273.486H388.289V274.471H389.517V273.486Z",
    fill: "#282142"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M387.105 285.229H385.877V286.216H387.105V285.229Z",
    fill: "#282142"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M374.819 285.229H373.59V286.216H374.819V285.229Z",
    fill: "#282142"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M384.648 285.229H383.42V286.216H384.648V285.229Z",
    fill: "#282142"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M387.06 273.486H385.832V274.471H387.06V273.486Z",
    fill: "#282142"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M384.604 273.486H383.375V274.471H384.604V273.486Z",
    fill: "#282142"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M382.147 273.486H380.918V274.471H382.147V273.486Z",
    fill: "#282142"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M364.944 273.486H363.716V274.471H364.944V273.486Z",
    fill: "#282142"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M364.989 285.229H363.761V286.216H364.989V285.229Z",
    fill: "#282142"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M362.488 273.486H361.259V274.471H362.488V273.486Z",
    fill: "#282142"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M362.532 285.229H361.301V286.216H362.532V285.229Z",
    fill: "#282142"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M367.401 273.486H366.173V274.471H367.401V273.486Z",
    fill: "#282142"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M372.317 273.486H371.089V274.471H372.317V273.486Z",
    fill: "#282142"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M374.774 273.486H373.545V274.471H374.774V273.486Z",
    fill: "#282142"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M372.362 285.229H371.131V286.216H372.362V285.229Z",
    fill: "#282142"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M369.903 285.229H368.674V286.216H369.903V285.229Z",
    fill: "#282142"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M369.858 273.486H368.629V274.471H369.858V273.486Z",
    fill: "#282142"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M367.446 285.229H366.218V286.216H367.446V285.229Z",
    fill: "#282142"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M450.842 279.196C450.798 278.767 450.708 278.352 450.576 277.957C450.441 277.553 450.268 277.168 450.054 276.807C449.844 276.439 449.592 276.097 449.309 275.786C449.025 275.472 448.708 275.188 448.366 274.942C448.024 274.695 447.66 274.484 447.27 274.313C446.888 274.142 446.485 274.011 446.067 273.924C445.666 273.839 445.248 273.794 444.821 273.794H206.995V274.779H444.821C447.618 274.779 449.895 277.053 449.895 279.849C449.895 282.645 447.618 284.923 444.821 284.923H206.995V285.907H444.855C445.287 285.904 445.705 285.857 446.112 285.767C446.529 285.677 446.93 285.542 447.312 285.369C447.699 285.195 448.066 284.982 448.406 284.732C448.745 284.48 449.056 284.196 449.339 283.882C449.62 283.568 449.87 283.223 450.077 282.853C450.29 282.488 450.461 282.104 450.59 281.697C450.719 281.302 450.806 280.887 450.848 280.458C450.868 280.259 450.879 280.054 450.879 279.849C450.879 279.628 450.868 279.409 450.842 279.196Z",
    fill: "#282142"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M235.42 277.847C234.376 276.641 232.551 276.512 231.345 277.556C230.139 278.602 230.01 280.427 231.056 281.633C232.102 282.836 233.925 282.968 235.131 281.922C236.337 280.876 236.466 279.053 235.42 277.847ZM234.371 281.044C233.65 281.67 232.559 281.591 231.933 280.87C231.308 280.15 231.384 279.059 232.105 278.433C232.825 277.808 233.919 277.886 234.542 278.607C235.167 279.328 235.091 280.419 234.371 281.044Z",
    fill: "#282142"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M265.565 277.847C264.519 276.641 262.693 276.512 261.487 277.556C260.284 278.602 260.152 280.427 261.198 281.633C262.244 282.836 264.067 282.968 265.273 281.922C266.479 280.876 266.608 279.053 265.565 277.847ZM264.513 281.044C263.792 281.67 262.702 281.591 262.076 280.87C261.451 280.15 261.529 279.059 262.25 278.433C262.971 277.808 264.062 277.886 264.687 278.607C265.312 279.328 265.234 280.419 264.513 281.044Z",
    fill: "#282142"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M295.707 277.847C294.661 276.641 292.838 276.512 291.632 277.556C290.426 278.602 290.297 280.427 291.341 281.633C292.387 282.836 294.212 282.968 295.418 281.922C296.622 280.876 296.753 279.053 295.707 277.847ZM294.656 281.044C293.935 281.67 292.844 281.591 292.219 280.87C291.593 280.15 291.672 279.059 292.392 278.433C293.113 277.808 294.204 277.886 294.83 278.607C295.455 279.328 295.377 280.419 294.656 281.044Z",
    fill: "#282142"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M325.85 277.847C324.806 276.641 322.981 276.512 321.775 277.556C320.569 278.602 320.44 280.427 321.486 281.633C322.529 282.836 324.355 282.968 325.561 281.922C326.767 280.876 326.896 279.053 325.85 277.847ZM324.801 281.044C324.08 281.67 322.989 281.591 322.364 280.87C321.738 280.15 321.814 279.059 322.535 278.433C323.256 277.808 324.347 277.886 324.972 278.607C325.597 279.328 325.522 280.419 324.801 281.044Z",
    fill: "#282142"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M355.995 277.847C354.949 276.641 353.123 276.512 351.918 277.556C350.715 278.602 350.583 280.427 351.629 281.633C352.675 282.836 354.498 282.968 355.704 281.922C356.909 280.876 357.038 279.053 355.995 277.847ZM354.944 281.044C354.223 281.67 353.132 281.591 352.506 280.87C351.881 280.15 351.96 279.059 352.68 278.433C353.401 277.808 354.492 277.886 355.117 278.607C355.743 279.328 355.664 280.419 354.944 281.044Z",
    fill: "#282142"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M386.8 279.235V279.233C386.713 278.736 386.494 278.257 386.138 277.847C385.092 276.641 383.269 276.512 382.063 277.555C380.857 278.601 380.728 280.427 381.771 281.633C382.764 282.774 384.458 282.951 385.658 282.073C385.723 282.026 385.787 281.975 385.849 281.922C386.643 281.232 386.971 280.203 386.8 279.235ZM385.086 281.044C384.365 281.67 383.274 281.591 382.649 280.87C382.023 280.15 382.102 279.059 382.823 278.433C383.543 277.808 384.634 277.886 385.26 278.607C385.885 279.328 385.807 280.419 385.086 281.044Z",
    fill: "#282142"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M416.28 277.847C415.237 276.641 413.411 276.512 412.205 277.556C410.999 278.602 410.87 280.427 411.916 281.633C412.96 282.836 414.785 282.968 415.991 281.922C417.197 280.876 417.326 279.053 416.28 277.847ZM415.231 281.044C414.511 281.67 413.42 281.591 412.794 280.87C412.169 280.15 412.245 279.059 412.965 278.433C413.686 277.808 414.777 277.886 415.402 278.607C416.028 279.328 415.952 280.419 415.231 281.044Z",
    fill: "#282142"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M446.425 277.847C445.379 276.641 443.554 276.512 442.348 277.556C441.145 278.602 441.013 280.427 442.059 281.633C443.105 282.836 444.928 282.968 446.134 281.922C447.34 280.876 447.469 279.053 446.425 277.847ZM445.374 281.044C444.653 281.67 443.562 281.591 442.937 280.87C442.311 280.15 442.39 279.059 443.111 278.433C443.831 277.808 444.922 277.886 445.548 278.607C446.173 279.328 446.095 280.419 445.374 281.044Z",
    fill: "#282142"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M339.941 236.51L339.281 235.973C345.087 228.834 347.452 222.881 346.509 217.771C345.226 210.817 337.912 206.6 331.459 202.879C327.836 200.791 324.415 198.818 322.482 196.581C321.032 194.902 320.431 193.083 320.696 191.175C321.297 186.849 326.122 183.626 326.327 183.491L326.796 184.202C326.749 184.233 322.085 187.352 321.539 191.295C321.311 192.949 321.845 194.54 323.127 196.024C324.965 198.153 328.326 200.091 331.884 202.142C338.497 205.955 345.991 210.276 347.346 217.617C348.337 222.986 345.915 229.166 339.941 236.51Z",
    fill: "#282142"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M359.813 259.829L356.944 257.994C361.658 250.622 361.657 243.933 356.94 238.65C349.1 229.869 333.182 236.81 333.022 236.881L331.633 233.771C331.817 233.689 336.203 231.749 341.762 231.044C349.374 230.078 355.5 231.924 359.481 236.382C365.24 242.832 365.358 251.159 359.813 259.829Z",
    fill: "#282142"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M289.17 189.002C289.063 188.781 286.555 183.529 285.989 176.985C285.216 168.05 288.444 161.078 295.326 156.82C300.353 153.711 305.885 152.81 311.327 154.216C317.603 155.837 322.606 160.3 324.011 162.805L321.04 164.471C320.104 162.801 315.914 158.919 310.475 157.514C305.89 156.329 301.396 157.07 297.118 159.717C291.321 163.303 288.718 169.014 289.382 176.692C289.895 182.618 292.213 187.472 292.236 187.52L289.17 189.002Z",
    fill: "#282142"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M325.97 160.137L317.761 164.877L319.062 167.131L327.272 162.391L325.97 160.137Z",
    fill: "#282142"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M388.509 154.203H382.904V180.172H388.509V154.203Z",
    fill: "#282142"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M389.103 172.249L382.534 172.245C381.367 173.198 380.623 174.648 380.625 176.272L380.634 181.024L391.016 181.012L391.007 176.26C391.005 174.643 390.264 173.2 389.103 172.249Z",
    fill: "#3561E4"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M391.994 181.007H379.724V182.495H391.994V181.007Z",
    fill: "#282142"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M377.182 208.087L375.079 208.395L369.113 192.966L374.847 192.128L377.182 208.087Z",
    fill: "#282142"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M399.036 207.973L401.16 207.892L404.213 191.635L398.423 191.855L399.036 207.973Z",
    fill: "#282142"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M392.424 188.08L380.071 188.072C378.566 188.071 377.336 186.839 377.337 185.334C377.338 183.829 378.57 182.599 380.075 182.6L392.427 182.608C393.932 182.609 395.163 183.841 395.162 185.346C395.161 186.851 393.929 188.081 392.424 188.08Z",
    fill: "#3561E4"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M381.489 183.489C380.633 182.55 379.184 182.462 378.222 183.293L370.144 190.261C368.276 191.84 368.305 194.73 370.205 196.271C372.013 197.736 374.693 197.304 375.948 195.345L381.729 186.336C382.302 185.442 382.204 184.275 381.489 183.489Z",
    fill: "#3561E4"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M371.635 192.201C370.989 193.015 371.33 194.208 372.308 194.557C372.9 194.769 373.581 194.575 373.973 194.082C374.618 193.269 374.277 192.075 373.3 191.726C372.707 191.514 372.026 191.709 371.635 192.201Z",
    fill: "#282142"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M378.708 184.542C378.212 185.167 378.474 186.084 379.225 186.352C379.68 186.515 380.204 186.366 380.504 185.987C381 185.362 380.738 184.446 379.987 184.177C379.532 184.014 379.009 184.163 378.708 184.542Z",
    fill: "#282142"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M390.643 183.605C391.367 182.56 392.791 182.282 393.855 182.978L402.782 188.82C404.842 190.139 405.194 193.007 403.514 194.785C401.916 196.476 399.202 196.401 397.7 194.625L390.78 186.458C390.094 185.648 390.037 184.477 390.643 183.605Z",
    fill: "#3561E4"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M391.584 184.9C391.433 185.683 392.089 186.375 392.88 186.266C393.358 186.199 393.753 185.825 393.844 185.35C393.995 184.567 393.339 183.875 392.549 183.984C392.07 184.05 391.675 184.425 391.584 184.9Z",
    fill: "#282142"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M399.037 191.739C398.84 192.759 399.694 193.659 400.723 193.517C401.346 193.43 401.86 192.943 401.979 192.325C402.175 191.305 401.321 190.405 400.293 190.547C399.669 190.634 399.156 191.121 399.037 191.739Z",
    fill: "#282142"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M386.775 152.835H366.123V159.48H386.775V152.835Z",
    fill: "#282142"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M368.637 163.431H355.258C351.241 163.431 347.985 160.174 347.985 156.157C347.985 152.14 351.241 148.884 355.258 148.884H368.637V163.431Z",
    fill: "#3561E4"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M385.967 163.43H376.539V148.884H385.967C389.984 148.884 393.24 152.141 393.24 156.157C393.24 160.174 389.984 163.43 385.967 163.43Z",
    fill: "#3561E4"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M387.683 159.629C385.733 160.446 383.483 159.525 382.666 157.576C381.849 155.627 382.77 153.376 384.719 152.559C386.668 151.742 388.919 152.663 389.736 154.612C390.553 156.561 389.632 158.812 387.683 159.629ZM385.343 154.047C384.214 154.52 383.681 155.823 384.154 156.952C384.627 158.081 385.93 158.614 387.059 158.141C388.187 157.668 388.721 156.365 388.248 155.236C387.774 154.108 386.471 153.574 385.343 154.047Z",
    fill: "#282142"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M328.539 186.698L317.008 168.849L313.282 171.256L324.814 189.105L328.539 186.698Z",
    fill: "#282142"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M291.923 197.636C290.193 194.946 290.971 191.363 293.661 189.632L323.46 170.447L329.726 180.188L299.927 199.373C297.237 201.104 293.654 200.326 291.923 197.636Z",
    fill: "#282142"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M327.154 189.421L359.393 165.547C363.535 162.479 364.576 156.717 361.769 152.393C358.961 148.07 353.274 146.677 348.786 149.214L313.93 168.952L327.154 189.421Z",
    fill: "#3561E4"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M356.96 162.979C354.066 164.859 350.181 164.033 348.302 161.139C346.422 158.244 347.248 154.36 350.142 152.48C353.037 150.601 356.921 151.426 358.801 154.321C360.681 157.215 359.855 161.1 356.96 162.979ZM351.577 154.69C349.901 155.779 349.423 158.028 350.512 159.704C351.6 161.38 353.849 161.858 355.525 160.769C357.201 159.681 357.679 157.432 356.591 155.756C355.502 154.08 353.253 153.602 351.577 154.69Z",
    fill: "#282142"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M339.695 247.625C331.851 254.427 319.979 253.582 313.177 245.739L282.303 210.135C275.501 202.292 276.346 190.419 284.19 183.617C292.034 176.816 303.906 177.66 310.708 185.504L341.582 221.107C348.383 228.951 347.539 240.823 339.695 247.625Z",
    fill: "#3561E4"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M289.298 189.508C285.168 193.089 284.724 199.339 288.305 203.469C291.886 207.599 298.137 208.044 302.266 204.463C306.396 200.881 306.841 194.631 303.26 190.501C299.678 186.371 293.428 185.926 289.298 189.508ZM299.66 201.457C297.19 203.598 293.453 203.332 291.311 200.862C289.169 198.393 289.435 194.655 291.904 192.514C294.374 190.372 298.112 190.638 300.253 193.108C302.395 195.577 302.129 199.315 299.66 201.457Z",
    fill: "#282142"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M346.472 251.07H312.311V236.415C312.311 226.981 319.958 219.334 329.391 219.334C338.825 219.334 346.471 226.982 346.471 236.415L346.472 251.07Z",
    fill: "#282142"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M324.492 230.296C321.251 233.107 320.902 238.014 323.713 241.255C326.524 244.496 331.43 244.846 334.672 242.035C337.914 239.224 338.262 234.317 335.451 231.076C332.64 227.835 327.734 227.485 324.492 230.296ZM332.626 239.676C330.687 241.356 327.754 241.148 326.072 239.209C324.391 237.27 324.6 234.337 326.538 232.656C328.477 230.975 331.411 231.184 333.092 233.122C334.773 235.061 334.564 237.994 332.626 239.676Z",
    fill: "#574A8F"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M352.102 249.347H308.428V262.179H352.102V249.347Z",
    fill: "#282142"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M367.189 267.246H289.572C289.532 267.602 289.51 267.964 289.51 268.332V305.587H367.251V268.332C367.251 267.964 367.23 267.602 367.189 267.246Z",
    fill: "#3561E4"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M350.232 255.523H306.473C297.11 258.067 290.259 262.446 289.545 268.662H367.161C366.446 262.447 359.595 258.067 350.232 255.523Z",
    fill: "#3561E4"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M369.561 294.254H287.723V305.59H369.561V294.254Z",
    fill: "#282142"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M320.953 278.021C319.798 278.021 318.862 277.085 318.862 275.93C318.862 274.775 319.798 273.839 320.953 273.839C322.108 273.839 323.044 274.775 323.044 275.93C323.044 277.084 322.108 278.021 320.953 278.021Z",
    fill: "#282142"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M328.04 278.021C326.886 278.021 325.949 277.085 325.949 275.93C325.949 274.775 326.885 273.839 328.04 273.839C329.195 273.839 330.131 274.775 330.131 275.93C330.132 277.084 329.195 278.021 328.04 278.021Z",
    fill: "#282142"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M335.128 278.021C333.973 278.021 333.037 277.085 333.037 275.93C333.037 274.775 333.973 273.839 335.128 273.839C336.283 273.839 337.219 274.775 337.219 275.93C337.219 277.084 336.283 278.021 335.128 278.021Z",
    fill: "#282142"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M342.216 278.021C341.061 278.021 340.125 277.085 340.125 275.93C340.125 274.775 341.061 273.839 342.216 273.839C343.371 273.839 344.307 274.775 344.307 275.93C344.307 277.084 343.371 278.021 342.216 278.021Z",
    fill: "#282142"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M310.752 292.445H298.214V280.932H310.752V292.445ZM298.408 292.251H310.558V281.126H298.408V292.251Z",
    fill: "#282142"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M302.038 262.252C303.313 260.418 305.223 259.125 307.119 257.988H306.198C304.302 259.125 302.391 260.418 301.115 262.252H302.038Z",
    fill: "#282142"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M304.229 262.252C305.501 260.418 307.411 259.126 309.304 257.988H308.384C306.49 259.125 304.579 260.418 303.306 262.252H304.229Z",
    fill: "#282142"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M306.42 262.252C307.689 260.418 309.599 259.126 311.49 257.988H310.57C308.678 259.125 306.768 260.418 305.497 262.252H306.42Z",
    fill: "#282142"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M308.611 262.252C309.877 260.418 311.788 259.126 313.676 257.988H312.756C310.866 259.126 308.956 260.418 307.689 262.252H308.611Z",
    fill: "#282142"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M310.803 262.252C312.066 260.418 313.976 259.126 315.862 257.988H314.942C313.055 259.126 311.144 260.418 309.88 262.252H310.803Z",
    fill: "#282142"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M312.994 262.252C314.253 260.418 316.164 259.126 318.048 257.988H317.128C315.243 259.126 313.332 260.418 312.071 262.252H312.994Z",
    fill: "#282142"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M315.185 262.252C316.442 260.418 318.353 259.126 320.234 257.988H319.313C317.431 259.126 315.52 260.418 314.262 262.252H315.185Z",
    fill: "#282142"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7508 252.049H22.546V273.296H46.7508V252.049Z",
    fill: "#E68D45"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0466 252.049H29.8418V273.296H54.0466V252.049Z",
    fill: "#FDB477"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5442 252.049H39.9301V256.336H42.5442V252.049Z",
    fill: "white"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3831 269.355H46.8663V271.76H49.3831V269.355Z",
    fill: "#E68D45"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8723 269.355H50.3553V271.76H52.8723V269.355Z",
    fill: "#E68D45"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8698 269.355H43.353V271.76H45.8698V269.355Z",
    fill: "#E68D45"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M199.895 252.049H175.69V273.296H199.895V252.049Z",
    fill: "#E68D45"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M207.191 252.049H182.986V273.296H207.191V252.049Z",
    fill: "#FDB477"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M195.688 252.049H193.074V256.336H195.688V252.049Z",
    fill: "white"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M202.527 269.355H200.01V271.76H202.527V269.355Z",
    fill: "#E68D45"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M206.016 269.355H203.499V271.76H206.016V269.355Z",
    fill: "#E68D45"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M199.013 269.355H196.497V271.76H199.013V269.355Z",
    fill: "#E68D45"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M126.736 252.049H102.532V273.296H126.736V252.049Z",
    fill: "#E68D45"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M134.032 252.049H109.827V273.296H134.032V252.049Z",
    fill: "#FDB477"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M122.53 252.049H119.916V256.336H122.53V252.049Z",
    fill: "white"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M129.368 269.355H126.852V271.76H129.368V269.355Z",
    fill: "#E68D45"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M132.857 269.355H130.341V271.76H132.857V269.355Z",
    fill: "#E68D45"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M125.855 269.355H123.338V271.76H125.855V269.355Z",
    fill: "#E68D45"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M268.06 252.049H243.855V273.296H268.06V252.049Z",
    fill: "#E68D45"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M275.355 252.049H251.15V273.296H275.355V252.049Z",
    fill: "#FDB477"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M263.853 252.049H261.239V256.336H263.853V252.049Z",
    fill: "white"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M270.692 269.355H268.175V271.76H270.692V269.355Z",
    fill: "#E68D45"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M274.18 269.355H271.664V271.76H274.18V269.355Z",
    fill: "#E68D45"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M267.178 269.355H264.661V271.76H267.178V269.355Z",
    fill: "#E68D45"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M400.843 252.049H376.638V273.296H400.843V252.049Z",
    fill: "#E68D45"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M408.138 252.049H383.934V273.296H408.138V252.049Z",
    fill: "#FDB477"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M396.636 252.049H394.022V256.336H396.636V252.049Z",
    fill: "white"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M403.475 269.355H400.958V271.76H403.475V269.355Z",
    fill: "#E68D45"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M406.964 269.355H404.447V271.76H406.964V269.355Z",
    fill: "#E68D45"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M399.961 269.355H397.445V271.76H399.961V269.355Z",
    fill: "#E68D45"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M387.551 145.365C386.721 146.121 385.427 146.068 384.661 145.246C383.895 144.425 383.948 143.146 384.778 142.389C385.609 141.633 386.902 141.686 387.668 142.508C388.434 143.329 388.382 144.609 387.551 145.365Z",
    fill: "#5F509C"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M394.129 137.352L394.13 137.352C394.375 137.097 394.375 136.692 394.121 136.445C389.579 132.017 382.621 131.895 377.933 136.159C377.671 136.398 377.657 136.803 377.894 137.066C378.136 137.333 378.554 137.362 378.823 137.122C383.003 133.388 389.147 133.495 393.2 137.377C393.46 137.626 393.879 137.611 394.129 137.352Z",
    fill: "#5F509C"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M392.237 139.314L392.24 139.311C392.492 139.049 392.479 138.635 392.214 138.386C388.689 135.085 383.412 134.992 379.777 138.164C379.503 138.403 379.476 138.817 379.72 139.087L379.723 139.091C379.961 139.354 380.369 139.384 380.639 139.153C383.774 136.475 388.276 136.554 391.318 139.345C391.58 139.585 391.99 139.57 392.237 139.314Z",
    fill: "#5F509C"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M390.401 141.216L390.407 141.21C390.662 140.946 390.649 140.522 390.372 140.278C387.835 138.05 384.169 137.984 381.557 140.117C381.271 140.35 381.243 140.774 381.491 141.048L381.496 141.054C381.73 141.313 382.126 141.343 382.4 141.127C384.517 139.46 387.437 139.513 389.494 141.258C389.761 141.484 390.159 141.468 390.401 141.216Z",
    fill: "#5F509C"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M282.109 114.332C282.18 112.604 280.82 111.144 279.072 111.073C277.324 111.001 275.849 112.344 275.778 114.072C275.707 115.8 277.067 117.259 278.815 117.331C280.563 117.403 282.038 116.06 282.109 114.332Z",
    fill: "#A9D0FF"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M291.286 104.116L291.287 104.116C291.667 103.721 291.666 103.094 291.273 102.711C284.238 95.8527 273.462 95.6643 266.2 102.268C265.794 102.638 265.772 103.265 266.14 103.672C266.514 104.087 267.162 104.132 267.578 103.759C274.053 97.9758 283.569 98.1425 289.846 104.154C290.25 104.541 290.899 104.518 291.286 104.116Z",
    fill: "#A9D0FF"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M288.355 107.155L288.359 107.15C288.75 106.745 288.73 106.104 288.319 105.718C282.859 100.605 274.686 100.46 269.056 105.373C268.632 105.744 268.59 106.385 268.968 106.804L268.973 106.809C269.341 107.217 269.974 107.263 270.392 106.906C275.247 102.757 282.22 102.881 286.931 107.203C287.338 107.575 287.973 107.551 288.355 107.155Z",
    fill: "#A9D0FF"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M285.512 110.102L285.521 110.092C285.916 109.682 285.896 109.025 285.467 108.649C281.537 105.198 275.859 105.095 271.813 108.398C271.37 108.759 271.328 109.416 271.71 109.84L271.719 109.85C272.081 110.251 272.694 110.297 273.119 109.963C276.397 107.38 280.92 107.462 284.107 110.165C284.52 110.515 285.136 110.491 285.512 110.102Z",
    fill: "#A9D0FF"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2437 112.185C59.2223 113.115 57.6307 113.05 56.6888 112.04C55.7468 111.029 55.8112 109.455 56.8326 108.525C57.8539 107.595 59.4456 107.66 60.3875 108.671C61.3297 109.682 61.2653 111.255 60.2437 112.185Z",
    fill: "#A9D0FF"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3351 102.33L68.3357 102.329C68.6379 102.016 68.6368 101.518 68.325 101.214C62.7378 95.7667 54.1801 95.6173 48.4132 100.862C48.0906 101.155 48.0731 101.653 48.3654 101.977C48.6627 102.306 49.1768 102.341 49.5079 102.046C54.65 97.4528 62.2075 97.5852 67.1919 102.359C67.512 102.666 68.0273 102.649 68.3351 102.33Z",
    fill: "#A9D0FF"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0069 104.743L66.0108 104.738C66.321 104.417 66.3053 103.907 65.9787 103.602C61.6431 99.5407 55.1521 99.4259 50.6809 103.327C50.3435 103.622 50.3108 104.131 50.6107 104.463L50.6145 104.468C50.9071 104.792 51.4096 104.828 51.7416 104.544C55.5974 101.25 61.1349 101.348 64.8765 104.78C65.1991 105.076 65.7037 105.057 66.0069 104.743Z",
    fill: "#A9D0FF"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7492 107.083L63.7564 107.075C64.0705 106.75 64.0543 106.228 63.7138 105.929C60.5933 103.188 56.0839 103.106 52.8703 105.729C52.5188 106.016 52.4849 106.539 52.7889 106.875L52.7961 106.883C53.0834 107.201 53.5702 107.238 53.9072 106.972C56.511 104.922 60.103 104.987 62.6339 107.133C62.9621 107.411 63.4511 107.392 63.7492 107.083Z",
    fill: "#A9D0FF"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M91.856 144.623L73.4567 154.631L64.0954 131.487L59.2826 132.697C59.2826 132.697 62.4019 159.582 67.4083 164.503C72.4147 169.425 97.9625 158.583 97.9625 158.583C104.223 154.579 98.5204 141.884 91.856 144.623Z",
    fill: "#F7A594"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4327 134.876C64.4327 134.876 66.0048 129.715 65.63 128.383C65.2551 127.051 60.094 125.762 59.9026 126.386C59.7113 127.01 59.3288 128.542 62.6834 129.132C60.6779 131.355 58.5896 135.609 64.4327 134.876Z",
    fill: "#F7A594"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7178 135.077C64.7178 135.077 64.718 130.554 63.8236 128.816C62.6326 126.502 59.6275 125.221 59.6275 125.221C59.6275 125.221 54.9339 129.662 54.8453 130.394C54.7566 131.126 59.3801 135.135 59.3801 135.135C59.3801 135.135 62.7978 137.828 64.7178 135.077Z",
    fill: "#F7A594"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5741 129.249C63.5741 129.249 61.3012 118.174 59.5678 118.662C58.7687 118.887 60.9021 129.466 60.9021 129.466L63.5741 129.249Z",
    fill: "#F7A594"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8703 133.413C64.8591 133.417 64.8461 133.418 64.8335 133.415C64.8012 133.407 64.7819 133.374 64.79 133.341C65.1763 131.83 65.7912 129.178 65.572 128.399C65.2828 127.372 61.8818 126.301 60.4559 126.285C60.0315 126.28 59.9689 126.375 59.9601 126.404C59.8338 126.816 59.745 127.303 60.0431 127.79C60.4155 128.397 61.3075 128.829 62.6941 129.073L62.8011 129.092L62.7284 129.173C61.8954 130.096 60.9292 131.516 60.7159 132.734C60.7101 132.767 60.6784 132.789 60.6461 132.783C60.6136 132.777 60.5914 132.746 60.5972 132.713C60.8088 131.506 61.7398 130.109 62.5669 129.173C61.2052 128.919 60.3218 128.475 59.9406 127.853C59.5738 127.254 59.7641 126.633 59.8451 126.369C59.8888 126.227 60.0885 126.16 60.4575 126.164C61.9024 126.181 65.3752 127.256 65.688 128.367C65.915 129.173 65.2963 131.848 64.9068 133.372C64.9019 133.391 64.8878 133.406 64.8703 133.413Z",
    fill: "#E6836F"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5892 131.851C58.5726 131.857 58.5562 131.863 58.5399 131.869L58.4995 131.882L58.4735 131.848C57.6499 130.781 55.8937 130.482 55.8762 130.479C55.8432 130.474 55.821 130.443 55.8264 130.41C55.8315 130.377 55.8629 130.355 55.8955 130.36C55.9688 130.372 57.6796 130.663 58.5417 131.74C58.5435 131.74 58.545 131.739 58.5468 131.738C59.5938 131.329 60.8702 128.646 60.8832 128.618C60.8973 128.588 60.933 128.575 60.9633 128.589C60.9936 128.603 61.0064 128.639 60.992 128.67C60.9382 128.783 59.6819 131.424 58.5892 131.851Z",
    fill: "#E6836F"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2145 143.448C95.2145 143.448 91.3607 143.962 82.1116 149.871C83.1392 153.854 86.2222 164.259 86.2222 164.259C86.2222 164.259 100.353 159.891 102.28 155.138C104.207 150.385 102.151 141.522 95.2145 143.448Z",
    fill: "white"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M140.35 305.421H125.745C125.445 305.249 125.222 305.055 125.091 304.834C124.338 293.972 123.255 288.743 123.255 288.743L133.427 288.329L135.729 296.409C139.137 298.738 143.199 303.734 140.35 305.421Z",
    fill: "#231F20"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M124.638 305.616H141.953C142.392 305.616 142.244 303.208 141.805 303.208L124.594 303.305C124.143 303.305 124.187 305.616 124.638 305.616Z",
    fill: "#231F20"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M118.605 189.736C123.694 197.563 127.411 235.384 134.423 292.33L124.057 292.876C120.943 277.708 117.432 270.018 113.866 248.153C105.325 228.855 100.895 210.572 98.6227 191.75C96.4128 177.561 113.834 170.109 118.605 189.736Z",
    fill: "#231F20"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M106.346 192.432C105.614 220.126 100.677 243.65 100.677 243.65C99.5454 266.842 98.0144 266.066 95.8669 293.098L86.4984 292.973C85.7103 281.391 79.4614 227.401 84.3139 192.748C86.6608 177.137 107.844 171.97 106.346 192.432Z",
    fill: "#231F20"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8668 293.097C96.7024 297.573 97.3023 301.065 96.9514 305.115L74.2615 305.557C74.2615 305.557 72.0156 303.369 74.8394 300.088C77.6633 296.807 83.0257 298.706 86.4983 292.973L95.8668 293.097Z",
    fill: "#231F20"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M73.231 305.616H97.3375C97.7765 305.616 97.6612 303.208 97.2222 303.208L73.2177 303.305C72.7661 303.305 72.7792 305.616 73.231 305.616Z",
    fill: "#231F20"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0122 191.123C85.0122 195.912 119.022 194.526 119.022 189.736C120.972 147.937 131.073 152.213 128.489 148.006C124.034 140.752 101.526 141.163 93.4221 144.281C90.2038 145.52 85.883 150.564 84.5009 158.606C83.7902 162.74 86.8348 167.555 87.3156 170.897C88.4287 178.631 85.2385 190.012 85.0122 191.123Z",
    fill: "white"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M106.213 147.572C111.955 148.408 115.526 144.401 116.366 142.725L115.964 131.105L109.382 130.464C107.473 130.623 105.564 131.08 103.923 131.728L102.441 139.38L102.115 141.039C101.369 142.672 100.472 146.737 106.213 147.572Z",
    fill: "#F7A594"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M113.749 133.736C112.717 135.325 108.394 139.394 102.442 139.38L103.723 132.76L113.749 133.736Z",
    fill: "#E6836F"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1817 118.43C98.6655 120.719 97.6022 125.745 97.7761 128.059C98.0408 131.583 101.332 135.491 104.202 136.005C107.525 136.343 112.004 135.354 114.436 133.264C115.79 131.678 118.41 127.915 119.615 124.621C122.13 117.751 117.275 111.726 111.117 110.334C104.958 108.943 100.791 111.293 99.1817 118.43Z",
    fill: "#F7A594"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M117.553 129.16C118.837 126.899 117.13 125.984 115.259 127.739C115.579 126.033 117.524 121.035 115.801 119.378C113.856 117.455 105.295 118.292 100.695 113.496C100.695 113.496 104.123 105.98 115.375 110.419C128.084 117.157 117.553 129.16 117.553 129.16Z",
    fill: "#73382A"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M115.96 127.011C114.987 128.194 114.946 129.763 115.868 130.517C116.79 131.27 118.326 130.921 119.299 129.738C120.272 128.555 120.313 126.985 119.391 126.232C118.469 125.479 116.933 125.828 115.96 127.011Z",
    fill: "#F7A594"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M126.156 145.655C122.332 145.197 118.584 163.659 121.21 168.718C121.217 169.092 121.222 169.47 121.232 169.851C121.261 171.291 121.297 172.778 121.342 174.281C121.364 174.946 121.386 175.616 121.407 176.285C121.458 177.762 121.516 179.246 121.574 180.718C122.043 192.126 122.752 202.77 122.752 202.77H82.92C83.2379 194.947 84.38 186.917 85.1606 180.718C85.363 179.104 85.5413 177.613 85.6715 176.285C85.7437 175.568 85.8016 174.898 85.8426 174.281C85.9413 172.804 85.9438 171.626 85.809 170.824C85.7632 170.547 85.7318 170.219 85.7199 169.851C85.52 164.025 89.4615 147.695 92.297 144.636C96.2746 142.793 100.592 142.646 100.592 142.646C100.312 150.95 103.615 158.402 103.615 158.402C103.615 158.402 112.05 151.162 116.649 142.549C120.689 143.197 124.373 144.009 126.156 145.655Z",
    fill: "#3561E4"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8424 174.281C85.9411 172.804 85.9436 171.626 85.8088 170.824C85.763 170.547 85.7316 170.219 85.7197 169.851H121.232C121.261 171.291 121.297 172.778 121.342 174.281H85.8424Z",
    fill: "white"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M121.573 180.718H85.1604C85.3627 179.104 85.5411 177.613 85.6712 176.285H121.407C121.458 177.762 121.516 179.246 121.573 180.718Z",
    fill: "white"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M102.011 114.532C102.011 114.532 98.4995 116.057 94.8492 114.578C95.4038 117.074 113.055 120.77 115.319 119.8C117.584 118.83 106.817 113.47 102.011 114.532Z",
    fill: "#5C2D22"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M121.536 122.762C122.026 119.173 122.584 109.958 114.424 107.589C107.172 105.483 101.97 109.842 99.5114 112.714C98.4472 112.878 95.5821 112.1 95.078 112.693C94.96 113.047 95.071 113.731 97.9842 114.886C97.9743 114.904 97.9689 114.914 97.9689 114.914C108.501 117.225 117.484 120.167 121.282 125.219C121.282 125.219 121.964 125.53 122.364 125.53C122.713 125.531 121.843 124.121 121.536 122.762Z",
    fill: "#FFB655"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M107.043 115.088C107.043 115.088 110.358 107.27 118.217 109.358L118.369 109.024C118.369 109.024 116.387 107.783 114.143 107.107C111.66 106.715 105.909 107.674 102.599 113.708C104.298 114.579 107.043 115.088 107.043 115.088Z",
    fill: "#FFDD69"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M121.627 166.439L127.193 178.8L104.584 190.074L105.005 194.83C105.005 194.83 134.847 191.031 137.466 184.485C140.084 177.939 129.466 149.865 129.466 149.865C126.482 142.704 122.494 160.465 121.627 166.439Z",
    fill: "#F7C4B9"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M104.662 190.38L93.5975 190.66C93.5975 190.66 96.9952 196.097 104.726 195.111C114.907 193.813 110.884 189.951 104.662 190.38Z",
    fill: "#F7C4B9"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M67.207 190.501V191.062C67.207 191.091 67.2093 191.119 67.2142 191.147C67.273 191.51 67.7086 191.793 68.2376 191.793H115.504C116.033 191.793 116.468 191.51 116.527 191.147C116.532 191.119 116.534 191.091 116.534 191.062V190.501H67.207Z",
    fill: "#5D4F99"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2142 191.146C67.273 191.51 67.7087 191.792 68.2376 191.792H115.504C116.033 191.792 116.468 191.51 116.527 191.146H67.2142Z",
    fill: "#241F3C"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7228 158.18L61.4498 158.448L61.5983 158.657L61.9496 158.165L61.7228 158.18Z",
    fill: "#241F3C"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M67.895 190.417H106.241C106.894 190.417 107.335 189.887 107.225 189.234L102.165 159.086C102.055 158.433 101.436 157.903 100.783 157.903H62.4372C61.7835 157.903 61.3427 158.433 61.4524 159.086L66.5129 189.234C66.6225 189.887 67.2415 190.417 67.895 190.417Z",
    fill: "#5D4F99"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6136 190.694H105.959C106.613 190.694 107.054 190.164 106.944 189.51L101.884 159.363C101.774 158.709 101.155 158.179 100.502 158.179H62.1559C61.5022 158.179 61.0613 158.709 61.171 159.363L66.2315 189.51C66.3412 190.164 66.9601 190.694 67.6136 190.694Z",
    fill: "#5D4F99"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2301 180.468C87.0077 180.148 88.9902 177.551 88.6581 174.667C88.3259 171.783 85.805 169.705 83.0274 170.025C80.2498 170.344 78.2674 172.942 78.5995 175.826C78.9316 178.71 81.4525 180.788 84.2301 180.468Z",
    fill: "#4BACEB"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M121.595 168.403L134.511 161.861C134.511 161.861 130.749 148.491 126.471 145.935C124.385 147.187 123.372 150.065 122.232 155.237C121.247 159.703 120.806 164.211 121.595 168.403Z",
    fill: "white"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M103.686 127.197C103.678 127.197 103.669 127.196 103.66 127.194C103.601 127.182 102.21 126.897 101.768 126.161C101.331 125.432 104.221 122.533 105.117 121.661C105.171 121.609 105.256 121.611 105.309 121.664C105.361 121.718 105.36 121.804 105.306 121.856C103.543 123.57 101.778 125.65 102.001 126.021C102.381 126.654 103.7 126.926 103.713 126.928C103.787 126.943 103.834 127.015 103.82 127.088C103.806 127.153 103.75 127.197 103.686 127.197Z",
    fill: "#73382A"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M105.948 130.239C103.635 130.239 101.69 129.446 101.659 129.433C101.59 129.404 101.557 129.324 101.586 129.255C101.615 129.186 101.694 129.153 101.763 129.182C101.812 129.203 106.725 131.202 110.122 128.747C110.183 128.703 110.268 128.716 110.312 128.777C110.356 128.838 110.342 128.923 110.281 128.967C108.939 129.937 107.373 130.239 105.948 130.239Z",
    fill: "#73382A"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M102.518 120.568C102.394 121.105 102.049 121.484 101.747 121.415C101.444 121.345 101.3 120.853 101.424 120.316C101.548 119.779 101.893 119.4 102.195 119.469C102.497 119.539 102.642 120.031 102.518 120.568Z",
    fill: "#5C2D22"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M111.254 122.81C111.066 123.385 110.652 123.764 110.329 123.659C110.006 123.553 109.897 123.002 110.085 122.428C110.273 121.853 110.687 121.474 111.01 121.579C111.333 121.685 111.442 122.236 111.254 122.81Z",
    fill: "#5C2D22"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M221.063 146.227C227.912 146.227 233.465 140.674 233.465 133.825C233.465 126.976 227.912 121.423 221.063 121.423C214.213 121.423 208.661 126.976 208.661 133.825C208.661 140.674 214.213 146.227 221.063 146.227Z",
    fill: "#0E0E0E"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M278.414 131.279L278.49 131.407C278.697 131.752 279.15 131.866 279.496 131.658L281.792 129.874C283.486 128.567 282.83 127.904 281.095 128.817L278.665 130.274C278.32 130.481 278.206 130.933 278.414 131.279Z",
    fill: "#FFA88F"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M273.484 138.487C273.484 138.487 280.938 137.974 279.894 130.713C279.455 127.661 271.155 131.495 271.155 131.495C271.155 131.495 272.229 126.671 270.446 127.104C269.661 130.475 268.918 133.684 268.266 136.64C268.224 137.82 271.331 139.46 273.484 138.487Z",
    fill: "#FFA88F"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M236.567 142.457C233.558 136.753 239.403 129.891 245.585 135.562L258.242 149.989L268.515 136.042C269.755 137.794 270.572 138.624 272.389 138.548C272.389 138.548 265.473 158.139 260.104 159.404C253.737 160.904 238.925 146.287 236.567 142.457Z",
    fill: "#FFA88F"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M281.352 125.128C281.422 124.307 280.302 123.638 280.193 124.158L274.626 122.754C274.241 122.657 273.839 122.922 273.729 123.348L269.94 137.962C269.826 138.403 270.05 138.845 270.442 138.95L276.103 140.465C276.119 140.548 276.167 140.632 276.257 140.715C276.904 140.897 277.299 140.657 277.507 140.323C277.569 140.235 277.617 140.132 277.646 140.018C277.672 139.822 281.345 125.323 281.352 125.128Z",
    fill: "black"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M276.195 140.702L269.694 138.977C269.288 138.869 269.055 138.414 269.173 137.961L273.082 122.935C273.196 122.498 273.611 122.226 274.01 122.328L280.401 123.957C280.803 124.06 281.04 124.499 280.93 124.939L277.143 140.071C277.029 140.528 276.604 140.81 276.195 140.702Z",
    fill: "black"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M276.313 140.616C276.285 140.612 276.257 140.607 276.23 140.599L269.732 138.868C269.383 138.775 269.182 138.377 269.285 137.981L273.188 122.971C273.287 122.589 273.648 122.35 273.991 122.437L280.384 124.06C280.394 124.062 280.404 124.065 280.414 124.068C280.573 124.117 280.704 124.229 280.784 124.383C280.866 124.541 280.886 124.727 280.84 124.908L277.048 140.055C276.958 140.414 276.643 140.655 276.313 140.616Z",
    fill: "black"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M280.597 124.926L276.813 140.019L269.49 138.08L273.391 123.064L280.597 124.926Z",
    fill: "#AAE0FF"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M276.907 134.084C277.136 134.464 277.634 134.589 278.015 134.361L281.208 132.446C281.589 132.218 281.714 131.72 281.485 131.339C281.257 130.958 280.759 130.834 280.378 131.062L277.185 132.976C276.804 133.205 276.679 133.703 276.907 134.084Z",
    fill: "#FFA88F"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M276.235 136.061C276.463 136.442 276.961 136.567 277.342 136.339L280.536 134.424C280.916 134.196 281.041 133.697 280.813 133.317C280.585 132.936 280.086 132.811 279.706 133.039L276.512 134.954C276.131 135.183 276.006 135.681 276.235 136.061Z",
    fill: "#FFA88F"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M276.942 137.134C277.123 137.435 277.517 137.534 277.819 137.353L280.346 135.838C280.647 135.657 280.746 135.263 280.566 134.961C280.385 134.66 279.991 134.561 279.689 134.742L277.162 136.257C276.86 136.438 276.762 136.832 276.942 137.134Z",
    fill: "#FFA88F"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M217.638 156.519C218.57 159.804 219.739 163.109 220.853 166.077C222.545 170.581 224.11 177.816 224.518 179.51L249.748 180.108C248.961 170.557 251.648 151.216 251.179 150.011C249.845 146.582 244.773 137.525 241.114 134.074C237.457 130.623 217.676 134.976 215.585 142.438C214.64 146.115 216.141 151.245 217.638 156.519Z",
    fill: "white"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M236.073 132.876C236.073 132.876 240.713 140.775 237.924 141.155C228.25 139.944 223.479 136.096 223.293 135.847C225.281 133.796 225.718 133.49 227.746 133.106C231.319 132.429 236.073 132.876 236.073 132.876Z",
    fill: "#FFA88F"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M235.714 193.043C226.746 224.862 207.868 287.225 207.868 287.225L199.55 285.77L214.636 192.425C217.723 179.192 238.142 173.692 235.714 193.043Z",
    fill: "#3561E4"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M193.014 303.591C191.079 302.073 195.27 300.174 195.27 300.174L199.576 286.27L199.596 285.897L208.482 285.896L209.101 291.468L201.363 303.59L193.014 303.591Z",
    fill: "#0D0D0D"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M204.709 303.589L203.562 290.733L209.115 291.431L205.987 303.589H204.709Z",
    fill: "#0D0D0D"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M233.422 192.02C235.049 225.038 242.601 290.245 242.601 290.245L251.033 289.79L254.631 196.742C254.478 179.501 235.383 172.616 233.422 192.02Z",
    fill: "#3561E4"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M255.709 305.616C257.648 304.103 253.461 302.194 253.461 302.194L251.673 288.286L251.654 287.913L242.768 287.89L242.135 293.46L247.36 305.595L255.709 305.616Z",
    fill: "#0D0D0D"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M244.014 305.586L247.677 292.74L242.121 293.424L242.737 305.583L244.014 305.586Z",
    fill: "#0D0D0D"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M223.945 175.618C223.945 175.618 214.868 181.551 214.209 195.203C224.582 197.053 254.301 199.767 254.301 199.767C254.936 190.182 253.407 181.405 249.562 175.88C228.582 174.865 223.945 175.618 223.945 175.618Z",
    fill: "#3561E4"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M231.135 121.755L231.53 123.935L232.952 131.766L233.436 134.433C233.271 137.322 225.765 137.71 223.63 135.72C223.603 135.201 223.528 133.988 223.438 132.529C223.27 129.795 223.043 126.199 222.955 124.679L222.934 124.281L226.16 123.287C227.987 122.725 229.975 122.111 231.135 121.755Z",
    fill: "#FFA88F"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M231.53 123.935L233.014 132.108C225.908 132.559 223.16 126.416 223.16 126.416L223.21 125.801C223.21 125.801 226.645 124.537 229.711 123.906C230.289 123.787 230.91 123.806 231.53 123.935Z",
    fill: "#FC8968"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M238.39 114.257C240.843 120.412 238.417 126.759 235.379 128.128C230.432 130.356 222.591 127.686 220.138 121.531C217.685 115.376 219.782 108.758 224.823 106.75C229.863 104.741 235.937 108.102 238.39 114.257Z",
    fill: "#FFA88F"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M232.948 107.179C232.948 107.179 223.587 112.742 223.005 127.786C215.261 121.598 213.329 115.151 217.334 109.337C220.918 104.134 228.367 103.759 232.948 107.179Z",
    fill: "#0E0E0E"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M232.26 107.654C232.26 107.654 235.621 108.269 238.319 114.082C236.922 108.879 230.944 99.9094 220.867 106.157C210.79 112.405 232.26 107.654 232.26 107.654Z",
    fill: "#0E0E0E"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M225.7 120.429C226.313 121.555 225.897 122.964 224.771 123.576C223.645 124.189 222.236 123.773 221.623 122.647C221.011 121.521 221.427 120.112 222.553 119.499C223.679 118.887 225.088 119.303 225.7 120.429Z",
    fill: "#FFA88F"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M234.804 119.994C234.753 119.994 234.706 119.961 234.691 119.909C234.673 119.847 234.708 119.782 234.77 119.763C234.781 119.76 235.898 119.423 236.176 118.847C236.188 118.823 236.198 118.787 236.173 118.728C235.982 118.284 234.453 117.713 233.88 117.53C233.818 117.511 233.784 117.445 233.804 117.383C233.823 117.321 233.889 117.287 233.951 117.306C234.172 117.377 236.121 118.012 236.389 118.636C236.435 118.743 236.435 118.852 236.388 118.95C236.064 119.619 234.887 119.974 234.837 119.989C234.826 119.992 234.815 119.994 234.804 119.994Z",
    fill: "#73382A"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M229.835 122.579C235.775 123.719 236.964 121.844 236.964 121.844C236.964 121.844 236.264 125.465 233.105 125.549C230.855 125.609 229.835 122.579 229.835 122.579Z",
    fill: "#F27550"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M235.303 114.186C235.452 114.64 235.779 114.94 236.035 114.856C236.29 114.772 236.376 114.337 236.227 113.883C236.078 113.43 235.751 113.13 235.496 113.214C235.241 113.297 235.154 113.733 235.303 114.186Z",
    fill: "#5C2D22"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M227.957 116.928C228.164 117.408 228.551 117.703 228.821 117.587C229.091 117.47 229.143 116.987 228.936 116.506C228.729 116.026 228.342 115.73 228.072 115.847C227.802 115.963 227.75 116.447 227.957 116.928Z",
    fill: "#5C2D22"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M214.968 119.912C213.856 116.436 211.696 107.389 219.38 103.615C226.21 100.262 232.133 103.68 235.073 106.101C236.157 106.078 238.865 104.807 239.469 105.308C239.648 105.638 239.657 106.336 236.967 107.991C236.98 108.007 236.987 108.016 236.987 108.016C226.938 112.145 218.536 116.63 215.649 122.307C215.649 122.307 215.026 122.734 214.628 122.804C214.283 122.865 214.901 121.315 214.968 119.912Z",
    fill: "#FFB655"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M228.013 109.77C228.013 109.77 223.36 102.59 215.925 106.032L215.716 105.727C215.716 105.727 217.466 104.149 219.575 103.088C221.971 102.266 227.845 102.215 232.183 107.625C230.649 108.787 228.013 109.77 228.013 109.77Z",
    fill: "#FFDD69"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M234.977 163.125C239.455 164.819 252.823 141.335 255.083 136.916C257.502 130.535 236.814 152.151 236.372 151.643C234.364 148.805 228.772 142.994 226.77 141.028C222.963 137.29 213.377 143.774 217.053 149.689C217.053 149.689 227.781 161.235 234.977 163.125Z",
    fill: "#FFA88F"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M252.931 140.254L250.406 139.672L252.591 132.688C252.591 132.688 253.421 132.351 254.569 132.355C255.727 132.359 256.819 132.927 256.819 132.927C256.819 132.927 257.624 135.478 257.677 135.891C258.07 138.97 252.931 140.254 252.931 140.254Z",
    fill: "#FFA88F"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M251.841 135.085C251.851 134.943 254.251 127.07 254.251 127.07C254.251 127.07 254.926 127.39 254.976 128.64C255.027 129.902 254.348 135.102 254.35 135.089L251.841 135.085Z",
    fill: "#FFA88F"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M257.013 133.832C255.964 133.358 255.178 133.475 255.171 133.477L255.148 133.338C255.183 133.333 255.981 133.211 257.071 133.704L257.013 133.832Z",
    fill: "#E6836F"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M257.297 134.786C256.248 134.312 255.462 134.43 255.454 134.431L255.432 134.292C255.465 134.286 256.265 134.166 257.355 134.659L257.297 134.786Z",
    fill: "#E6836F"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M257.581 135.998C256.532 135.524 255.746 135.642 255.738 135.643L255.716 135.504C255.75 135.499 256.548 135.377 257.638 135.87L257.581 135.998Z",
    fill: "#E6836F"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M189.485 186.81L153.776 187.516L154.155 137.345C158.754 130.086 185.302 131.573 189.12 137.331L189.485 186.81Z",
    fill: "white"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M146.168 287.622L145.893 296.576L156.184 299.458L157.767 288.952L146.168 287.622Z",
    fill: "#F7A58E"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M157.322 305.615L156.619 296.496C156.619 296.496 151.617 298.904 149.938 297.555C149.418 293.21 144.291 292.656 141.668 296.743L134.656 300.185L136.938 305.615H157.322Z",
    fill: "#DE7C44"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M142.436 305.615C141.315 302.228 139.109 299.914 136.59 299.914C133.687 299.914 131.359 301.82 130.59 305.615H142.436Z",
    fill: "#B36132"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M198.458 287.622L198.734 296.576L188.443 299.458L186.86 288.952L198.458 287.622Z",
    fill: "#F7A58E"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M187.305 305.615L188.008 296.496C188.008 296.496 193.011 298.904 194.689 297.555C195.209 293.21 200.336 292.656 202.959 296.743L209.971 300.185L207.689 305.615H187.305Z",
    fill: "#DE7C44"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M202.191 305.615C203.312 302.228 205.518 299.914 208.037 299.914C210.94 299.914 213.268 301.82 214.037 305.615H202.191Z",
    fill: "#B36132"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M178.431 138.574C177.557 143.661 166.071 143.661 164.728 138.574L165.349 130.373L165.532 127.959H177.625L177.923 131.87L178.431 138.574Z",
    fill: "#F7A58E"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M177.978 131.786C172.569 135.113 168.005 132.572 165.405 130.289L165.587 127.875H177.681L177.978 131.786Z",
    fill: "#DE8A73"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M164.74 134.743C165.785 138.346 168.464 139.514 171.895 141.087C174.863 139.6 176.768 138.205 178.233 134.743L179.766 136.787C179.766 136.787 180.175 144.76 171.793 144.76C162.767 144.76 163.104 138.321 163.104 138.321L164.74 134.743Z",
    fill: "white"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M199.291 292.516L186.753 293.33L171.764 211.513L158.318 293.33L146.165 292.516C144.886 257.432 150.818 196.901 153.255 169.675C153.451 167.484 153.664 165.51 153.894 163.78L155.921 158.63L160.274 147.574L181.966 147.447L186.654 158.63L189.24 164.8C189.526 165.707 189.799 167.613 190.059 170.333C192.036 191.182 200.779 259.817 199.291 292.516Z",
    fill: "#3561E4"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M190.059 170.334C173.542 165.259 158.642 168.195 153.256 169.675C153.451 167.484 153.665 165.51 153.894 163.78L155.921 158.63H186.655L189.241 164.8C189.526 165.708 189.8 167.613 190.059 170.334Z",
    fill: "#231F20"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M159.699 172.007H183.859C183.859 172.007 188.497 188.562 171.973 188.562C155.448 188.562 159.699 172.007 159.699 172.007Z",
    fill: "#0F4CA8"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M158.871 133.782L160.53 149.999L163.667 149.768L162.11 133.272L158.871 133.782Z",
    fill: "#002E73"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M183.394 133.782L181.735 149.999L178.598 149.768L180.155 133.272L183.394 133.782Z",
    fill: "#002E73"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M145.759 287.581L159.435 288.644C159.435 288.644 160.189 288.736 159.938 291.14C159.686 293.543 159.083 293.913 159.083 293.913L145.407 292.989C144.553 292.111 145.157 288.655 145.759 287.581Z",
    fill: "#0F4CA8"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M199.762 288.255L186.086 289.318C186.086 289.318 185.332 289.411 185.583 291.814C185.835 294.218 186.438 294.588 186.438 294.588L200.114 293.663C200.969 292.785 200.364 289.329 199.762 288.255Z",
    fill: "#0F4CA8"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M182.06 159.539C180.595 160.233 179.129 160.871 177.672 161.456C173.911 162.965 170.214 164.114 166.772 164.902C156.888 167.167 149.117 166.464 148.058 162.8C146.489 157.368 148.471 139.874 155.619 135.927C157.83 138.97 157.723 143.08 157.471 146.683C156.631 150.371 156.184 154.126 155.833 156.393C156.726 156.016 157.905 155.669 159.281 155.365C165.036 154.097 174.241 153.589 180.37 154.796C182.724 155.259 182.65 158.875 182.06 159.539Z",
    fill: "#F7A58E"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M177.853 161.006C177.863 161.105 177.8 161.261 177.672 161.456C173.911 162.965 170.214 164.114 166.772 164.903C166.76 164.888 166.75 164.874 166.741 164.86C163.673 160.482 155.833 156.393 155.833 156.393C156.825 155.824 158 155.501 159.281 155.365C166.715 154.573 177.757 160.113 177.853 161.006Z",
    fill: "#DE7F64"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M193.467 164.012C191.318 171.339 171.962 164.221 159.393 156.933C159.12 155.357 158.973 154.171 160.857 152.948C169.383 152.19 182.52 155.236 185.944 156.08C186.461 156.207 186.757 156.285 186.782 156.291C186.744 156.227 185.774 154.616 185.198 151.29C185.037 150.35 184.905 149.273 184.836 148.056C183.793 142.432 186.55 138.163 188.216 136.326C192.104 138.664 195.404 157.408 193.467 164.012Z",
    fill: "#F7A58E"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M157.702 134.583C150.118 137.656 148.68 144.92 148.68 144.92L157.216 149.396C157.216 149.396 160.276 140.971 157.702 134.583Z",
    fill: "white"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M186.888 135.544C181.345 139.62 184.592 150.396 184.592 150.396L194.385 145.216L194.474 145.083C194.474 145.083 191.502 137.585 186.888 135.544Z",
    fill: "white"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M160.856 152.948C160.856 152.948 157.603 152.499 156.229 153.736C155.845 155.605 155.833 156.392 155.833 156.392C155.833 156.392 158.098 156.045 159.417 157.034C160.737 158.024 164.191 152.902 160.856 152.948Z",
    fill: "#F7A58E"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M187.16 156.554C188.171 156.188 189.481 155.541 189.698 155.428C190.474 155.021 190.232 154.122 189.875 154.372L187.004 155.235C187.004 155.235 187.75 154.259 187.962 153.531C188.175 152.802 187.495 152.658 187.495 152.658L185.384 154.584C185.664 154.053 186.313 152.017 185.095 151.995C184.845 153.26 183.817 154.613 183.289 155.48C184.419 155.763 185.956 156.05 187.16 156.554Z",
    fill: "#F7A58E"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M187.184 156.62L187.136 156.487C188.149 156.121 189.465 155.47 189.665 155.365C190.108 155.133 190.141 154.777 190.141 154.673C190.14 154.529 190.087 154.437 190.035 154.409C190.001 154.392 189.961 154.399 189.916 154.431L189.895 154.44L186.815 155.366L186.948 155.193C186.955 155.183 187.688 154.219 187.894 153.511C187.955 153.305 187.944 153.131 187.862 152.995C187.764 152.83 187.588 152.76 187.514 152.737L185.132 154.91L185.322 154.551C185.544 154.13 185.944 152.896 185.615 152.339C185.518 152.174 185.366 152.086 185.152 152.069C184.936 153.071 184.265 154.101 183.723 154.933C183.585 155.145 183.457 155.341 183.35 155.517L183.229 155.444C183.337 155.266 183.466 155.069 183.604 154.855C184.15 154.018 184.83 152.976 185.026 151.982L185.038 151.923L185.097 151.925C185.391 151.93 185.606 152.045 185.737 152.267C186.043 152.786 185.797 153.753 185.584 154.307L187.475 152.582L187.51 152.589C187.523 152.592 187.827 152.659 187.984 152.923C188.087 153.094 188.102 153.306 188.031 153.551C187.868 154.108 187.41 154.793 187.186 155.107L189.845 154.308C189.931 154.252 190.021 154.243 190.101 154.284C190.212 154.342 190.282 154.491 190.283 154.673C190.283 154.797 190.244 155.222 189.731 155.491C189.529 155.596 188.204 156.251 187.184 156.62Z",
    fill: "#DE7F64"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M187.926 156.961C174.086 152.281 160.991 153.011 160.86 153.019L160.852 152.878C160.983 152.87 174.106 152.139 187.971 156.827L187.926 156.961Z",
    fill: "#F7F1F0"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M155.968 156.241L155.828 156.223C155.83 156.207 156.033 154.6 156.247 153.013C156.687 149.742 156.727 149.742 156.815 149.742V149.812L156.871 149.853C156.776 150.047 156.279 153.78 155.968 156.241Z",
    fill: "#DE7F64"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M182.746 118.353C182.294 124.813 177.825 131.514 171.754 131.951C167.384 132.066 160.957 125.056 160.761 118.353C159.153 97.772 184.363 97.7787 182.746 118.353Z",
    fill: "#F7A58E"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M161.793 121.078C161.619 121.164 161.422 121.201 161.236 121.201C160.402 121.213 159.509 120.523 159.068 119.413C158.523 118.057 158.859 116.615 159.822 116.171C160.1 116.048 160.413 116.023 160.715 116.085C161.433 116.233 162.164 116.874 162.547 117.836C163.092 119.191 162.755 120.634 161.793 121.078Z",
    fill: "#F7A58E"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M184.254 119.413C183.847 120.424 183.071 121.078 182.317 121.176C182.05 121.226 181.783 121.189 181.528 121.078C181.007 120.843 180.67 120.289 180.566 119.623C180.462 119.093 180.52 118.476 180.763 117.872C180.763 117.86 180.775 117.848 180.775 117.836C181.192 116.8 182.004 116.122 182.792 116.06C183.036 116.036 183.279 116.073 183.511 116.171C184.462 116.615 184.799 118.057 184.254 119.413Z",
    fill: "#F7A58E"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M160.715 116.085C159.658 114.376 159.411 111.11 159.733 106.753C159.733 106.753 161.954 101.548 171.739 101.548C181.524 101.548 183.713 107.141 183.713 107.141C183.753 110.785 183.841 114.524 182.792 116.06C182.191 116.414 181.829 117.127 181.471 117.845C181.654 115.592 181.698 113.206 181.038 110.154C181.038 110.154 179.58 107.378 171.253 107.378C162.925 107.378 162.162 110.362 162.162 110.362C161.85 113.408 161.808 115.955 162.258 117.592C162.067 117.029 161.82 116.477 160.715 116.085Z",
    fill: "#231F20"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M184.497 112.39L159.039 112.069C159.016 111.586 159.01 111.115 159.02 110.658C159.202 101.638 165.332 97.3437 171.691 97.507C182.343 97.7813 184.162 106.814 184.452 110.67C184.531 111.723 184.497 112.39 184.497 112.39Z",
    fill: "#FFDD69"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M173.453 111.175H169.052L169.63 97H172.874L173.453 111.175Z",
    fill: "#FFE99E"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M184.497 112.39L159.039 112.069C159.016 111.585 159.01 111.115 159.02 110.658C167.249 108.772 175.73 108.795 184.452 110.67C184.531 111.723 184.497 112.39 184.497 112.39Z",
    fill: "#E8A64D"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M157.809 111.37C166.806 109.096 176.105 109.122 185.696 111.37C185.696 111.37 187.231 114.354 171.213 114.354C157.394 114.354 157.809 111.37 157.809 111.37Z",
    fill: "#FFDD69"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M173.113 122.463C173.106 122.467 173.099 122.47 173.092 122.473C173.042 122.49 171.872 122.903 171.209 122.55C170.554 122.201 171.413 118.728 171.692 117.673C171.709 117.609 171.774 117.572 171.837 117.588C171.9 117.605 171.938 117.67 171.921 117.733C171.373 119.811 170.987 122.163 171.321 122.341C171.891 122.644 173.001 122.253 173.012 122.25C173.073 122.228 173.141 122.26 173.163 122.321C173.183 122.375 173.16 122.434 173.113 122.463Z",
    fill: "#73382A"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M171.898 126.416C169.876 126.416 168.177 125.723 168.149 125.711C168.089 125.686 168.06 125.617 168.085 125.556C168.111 125.496 168.18 125.467 168.241 125.493C168.284 125.511 172.577 127.258 175.546 125.112C175.599 125.074 175.673 125.086 175.712 125.139C175.75 125.192 175.738 125.266 175.685 125.305C174.512 126.152 173.143 126.416 171.898 126.416Z",
    fill: "#73382A"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M166.775 117.2C166.822 117.848 166.565 118.395 166.2 118.422C165.836 118.449 165.502 117.945 165.454 117.296C165.406 116.648 165.664 116.101 166.029 116.074C166.393 116.047 166.727 116.551 166.775 117.2Z",
    fill: "#231F20"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M178.012 117.517C177.944 118.164 177.594 118.658 177.231 118.619C176.867 118.581 176.627 118.026 176.695 117.38C176.762 116.733 177.112 116.24 177.475 116.278C177.839 116.316 178.079 116.871 178.012 117.517Z",
    fill: "#231F20"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M165.277 128.242C165.277 128.242 167.738 131.904 171.632 133.143C176.269 131.656 177.949 129.092 177.949 129.092C177.949 129.092 174.335 131.026 171.507 131.039C168.316 131.053 165.277 128.242 165.277 128.242Z",
    fill: "#231F20"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M157.533 304.611H132.221V305.657H157.533V304.611Z",
    fill: "#B36132"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M212.309 304.593H186.997V305.639H212.309V304.593Z",
    fill: "#B36132"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M158.893 110.915C158.753 110.912 158.496 99.7896 168.929 97.6961C165.775 98.6746 160.458 102.903 161.096 109.167C161.226 110.446 164.208 109.622 164.208 109.622L158.893 110.915Z",
    fill: "white"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M456.558 306H4V307H456.558C456.802 307 457 306.776 457 306.5C457 306.224 456.802 306 456.558 306Z",
    fill: "#0D0D0D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_837_235",
    x: 0.0373135,
    y: 0.0373135,
    width: 460.925,
    height: 310.925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.98134
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_837_235"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_837_235",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDvtBenefits1);
export default __webpack_public_path__ + "static/media/dvt_benefits1.4aaa31c11036f9988dc5a633729c5018.svg";
export { ForwardRef as ReactComponent };